window.opgPick = function (k, v) {
  try {
    if (v === undefined) return JSON.parse(sessionStorage.getItem('opg-pick-' + k) || '{}') || {};
    sessionStorage.setItem('opg-pick-' + k, JSON.stringify(v));
  } catch (e) { return {}; }
};
var opgPick = window.opgPick;
window.opgArtHref = function (title, collection) {
  var n = function (x) { return String(x || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim(); };
  var t = n(title), m = (window.OPG && OPG.art) || {}, best = null;
  Object.keys(m).forEach(function (k) { var nk = n(k); if (nk === t || (nk.indexOf(t) > -1 && (!best || nk.length < n(best).length))) best = k; });
  if (best) return m[best];
  var c = /obsidian/i.test(collection) ? '/one-of-one-art/obsidian-society/' : /highland/i.test(collection) ? '/one-of-one-art/highland-cows/' : '/art-collection/';
  var real = (window.OPG && OPG.real) || {};
  return real[c] || '/#' + c;
};
var {
  AnnouncementBar,
  Header,
  MobileNav,
  Footer,
  Hero,
  EditorialSplit,
  HowItWorksTimeline,
  TestimonialFeature,
  FounderFeature,
  Manifesto,
  FaqAccordion,
  AudienceSelector,
  FullBleedBanner,
  BeforeAfterSlider,
  TransformationTriptych,
  ProductCard,
  ArtworkCard,
  MediaPlaceholder,
  Eyebrow,
  Button,
  TextLink,
  Tag,
  Badge,
  CartDrawer,
  Icon
} = window.OnePrintGalleryDesignSystem_ba4735;
var useOpgMQ = q => {
  var [m, setM] = React.useState(() => typeof matchMedia !== 'undefined' && matchMedia(q).matches);
  React.useEffect(() => {
    var mq = matchMedia(q), f = e => setM(e.matches);
    setM(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', f) : mq.addListener(f);
    return () => { mq.removeEventListener ? mq.removeEventListener('change', f) : mq.removeListener(f); };
  }, [q]);
  return m;
};
var ProductCarousel = _ref => {
  var { media } = _ref;
  var [idx, setIdx] = React.useState(0);
  var track = React.useRef(null);
  var show = i => { var el = track.current; if (el) el.scrollTo({ left: i * el.clientWidth, behavior: 'smooth' }); setIdx(i); };
  var onScroll = () => { var el = track.current; if (!el) return; var i = Math.round(el.scrollLeft / el.clientWidth); if (i !== idx) setIdx(i); };
  return React.createElement("div", { style: { minWidth: 0, display: 'grid', gap: 12 } },
    React.createElement("div", { ref: track, className: "opg-car", onScroll: onScroll, role: "region", "aria-label": "Product images, swipe for more", tabIndex: 0, style: { display: 'flex', overflowX: 'auto', scrollSnapType: 'x mandatory', overscrollBehaviorX: 'contain', borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border)', background: 'var(--opg-white)' } },
      media.map((m, i) => React.createElement("img", { key: i, src: m.src, alt: m.note, loading: i ? "lazy" : "eager", decoding: "async", draggable: false, style: { flex: '0 0 100%', width: '100%', maxWidth: 'none', aspectRatio: '4 / 5', objectFit: m.fit, scrollSnapAlign: 'start', display: 'block' } }))),
    React.createElement("ul", { className: "opg-car", style: { listStyle: 'none', margin: 0, padding: 2, display: 'flex', gap: 8, overflowX: 'auto' } },
      media.map((m, i) => React.createElement("li", { key: i, style: { flex: 'none' } }, React.createElement("button", { type: "button", onClick: () => show(i), "aria-label": 'Show image ' + (i + 1) + ': ' + m.note, "aria-current": i === idx, style: { display: 'block', width: 60, height: 60, padding: 0, background: 'var(--opg-white)', border: '1px solid ' + (i === idx ? 'var(--color-brand)' : 'var(--color-border)'), boxShadow: i === idx ? '0 0 0 1px var(--color-brand)' : 'none', borderRadius: 'var(--radius-sm)', overflow: 'hidden', cursor: 'pointer', opacity: i === idx ? 1 : .7 } }, React.createElement("img", { src: m.src, alt: "", loading: "lazy", style: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' } }))))));
};
var HeroFilm = _ref => {
  var {
    page
  } = _ref;
  var narrow = useOpgMQ('(max-width:768px)');
  var pg = page === 'home' ? (narrow ? 'home-full' : 'home-tall') : page;
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'relative',
      width: '100%',
      aspectRatio: pg === 'home-full' ? '1122 / 1402' : pg === 'home-tall' ? '16 / 10' : '21 / 9',
      overflow: 'hidden',
      background: page === 'album' ? '#364370' : 'var(--opg-paper)'
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    srcDoc: window.OPG_HERO_DOC(pg),
    title: "",
    tabIndex: -1,
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      border: 0,
      pointerEvents: 'none'
    }
  }));
};
var Section = _ref2 => {
  var {
    tone = 'white',
    pad = 'standard',
    children,
    style
  } = _ref2;
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: {
        white: 'var(--opg-white)',
        paper: 'var(--opg-paper)',
        blush: 'var(--opg-blush-100)',
        navy: 'var(--opg-navy-700)',
        ink: 'var(--opg-navy-900)'
      }[tone],
      paddingBlock: pad === 'compact' ? 'var(--section-compact)' : pad === 'editorial' ? 'var(--section-editorial)' : 'var(--section-standard)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)'
    }
  }, children));
};
var SectionHead = _ref3 => {
  var {
    eyebrow,
    heading,
    body,
    onDark,
    align = 'left',
    max = '24ch'
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: '18px',
      justifyItems: align === 'center' ? 'center' : 'start',
      textAlign: align,
      marginBottom: 'var(--space-7)'
    }
  }, eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    onDark: onDark
  }, eyebrow) : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      letterSpacing: 'var(--tracking-display)',
      color: onDark ? 'var(--opg-white)' : 'var(--color-brand)',
      maxWidth: max
    }
  }, heading), body ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: onDark ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)',
      maxWidth: '58ch'
    }
  }, body) : null);
};

/* Section 3 — compact proof row. Words, not an app-icon strip. */
var ProofRow = () => /*#__PURE__*/React.createElement(Section, {
  tone: "paper",
  pad: "compact"
}, /*#__PURE__*/React.createElement("ul", {
  "data-opg-cols": "",
  style: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))',
    gap: 'var(--space-5) var(--grid-gap-lg)'
  }
}, ['Created from your own photos', 'Carefully transformed & refined', 'Optional preview by request', 'Made to order in 2–4 business days'].map((p, i) => /*#__PURE__*/React.createElement("li", {
  key: p,
  style: {
    paddingTop: 'var(--space-4)',
    borderTop: '1px solid var(--color-border-strong)'
  }
}, /*#__PURE__*/React.createElement("span", {
  style: {
    display: 'block',
    fontFamily: 'var(--font-display)',
    fontWeight: 600,
    fontSize: 'var(--text-lg)',
    color: 'var(--color-accent-warm)',
    lineHeight: 1
  }
}, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("span", {
  style: {
    display: 'block',
    marginTop: 10,
    fontFamily: 'var(--font-sans)',
    fontSize: 'var(--text-sm)',
    fontWeight: 600,
    color: 'var(--color-brand)',
    lineHeight: 1.45
  }
}, p)))));

/* Us vs them — personalised vs generic. Ours is the raised navy card; theirs recedes. */
var UVT_OURS = ['Made from your own family photos', 'Completely one of a kind', 'Every page starts a conversation', 'A keepsake worth keeping once it’s coloured'];
var UVT_THEIRS = ['Mass-produced stock designs', 'The same book on every shelf', 'No personal connection to the pages', 'Easily forgotten in a drawer'];
var UsVsThem = _ref4 => {
  var {
    tone = 'paper',
    onCta,
    genericSrc = OPG_A('../../assets/web/compare/traditional-book.webp')
  } = _ref4;
  var pv = 'clamp(24px,3.5vw,40px)';
  var pad = {
    paddingInline: pv
  };
  var card = {
    minWidth: 0,
    gridRow: '1 / span 7',
    display: 'grid',
    gridTemplateRows: 'subgrid',
    borderRadius: 'var(--radius-lg, 16px)',
    overflow: 'hidden'
  };
  var media = {
    position: 'relative',
    background: 'var(--opg-paper)',
    padding: 'clamp(24px,4vw,44px)',
    display: 'grid',
    placeItems: 'center'
  };
  var cover = {
    width: '70%',
    aspectRatio: '1122 / 1402',
    objectFit: 'cover',
    borderRadius: 4,
    display: 'block'
  };
  var li = {
    display: 'flex',
    gap: 14,
    alignItems: 'center',
    padding: '14px 0',
    fontSize: 'var(--text-base)',
    lineHeight: 1.5
  };
  var tag = {
    fontFamily: 'var(--font-sans)',
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: 'var(--tracking-eyebrow)',
    textTransform: 'uppercase'
  };
  var ttl = {
    margin: 0,
    fontFamily: 'var(--font-display)',
    fontWeight: 600,
    fontSize: 'var(--text-2xl)',
    lineHeight: 1.1
  };
  return /*#__PURE__*/React.createElement(Section, {
    tone: tone,
    pad: "editorial"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    align: "center",
    max: "22ch",
    eyebrow: "Personalised vs Traditional",
    heading: "Why choose us over a traditional colouring book."
  }), /*#__PURE__*/React.createElement("div", {
    className: "opg-uvt",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
      gridTemplateRows: 'auto auto repeat(4, auto) 1fr',
      columnGap: 'clamp(12px,2.5vw,32px)',
      maxWidth: 1120,
      marginInline: 'auto'
    }
  }, /*#__PURE__*/React.createElement("article", {
    style: {
      ...card,
      gridColumn: 1,
      background: 'var(--opg-navy-700)',
      color: 'var(--opg-white)',
      boxShadow: '0 30px 60px -28px rgba(10,20,50,.55)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: media
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/books/luna-front.webp"),
    alt: "Adventures of Luna, a personalised colouring book cover",
    style: {
      ...cover,
      boxShadow: '0 22px 40px -18px rgba(10,20,50,.45)',
      transform: 'rotate(-2deg)'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      ...tag,
      position: 'absolute',
      top: 18,
      left: 18,
      padding: '7px 12px',
      borderRadius: 'var(--radius-round)',
      background: 'var(--opg-navy-700)',
      color: 'var(--opg-peach-300)'
    }
  }, "One of One")), /*#__PURE__*/React.createElement("div", {
    style: {
      ...pad,
      paddingTop: pv,
      paddingBottom: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      ...ttl,
      marginTop: 0,
      color: 'var(--opg-white)'
    }
  }, "Personalised Colouring Book")), UVT_OURS.map((t, i) => /*#__PURE__*/React.createElement("div", {
    key: t,
    style: {
      ...pad,
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...li,
      flex: 1,
      borderTop: i ? '1px solid rgba(255,255,255,.14)' : 'none',
      fontWeight: 600
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 'none',
      width: 26,
      height: 26,
      borderRadius: '50%',
      background: 'var(--opg-peach-300)',
      color: 'var(--opg-navy-700)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    size: 15,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("span", null, t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      ...pad,
      paddingBottom: pv
    }
  }, onCta ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "onDark",
    size: "lg",
    onClick: onCta
  }, "Create Your Book"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)'
    }
  }, "From \xA314.99")) : null)), /*#__PURE__*/React.createElement("article", {
    style: {
      ...card,
      gridColumn: 2,
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: media
  }, genericSrc ? /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: genericSrc,
    alt: "A traditional mass-market colouring book cover",
    style: {
      ...cover,
      boxShadow: '0 12px 24px -16px rgba(10,20,50,.35)',
      filter: 'saturate(.6)',
      opacity: .88
    }
  }) : /*#__PURE__*/React.createElement(MediaPlaceholder, {
    label: "[GENERIC COLOURING BOOK PHOTO]",
    ratio: "4 / 3",
    rounded: "none"
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      ...tag,
      position: 'absolute',
      top: 18,
      left: 18,
      padding: '7px 12px',
      borderRadius: 'var(--radius-round)',
      background: 'var(--opg-white)',
      color: 'var(--color-text-muted)',
      border: '1px solid var(--color-border)'
    }
  }, "Standard")), /*#__PURE__*/React.createElement("div", {
    style: {
      ...pad,
      paddingTop: pv,
      paddingBottom: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      ...ttl,
      marginTop: 0,
      color: 'var(--color-text-muted)'
    }
  }, "Traditional Colouring Book")), UVT_THEIRS.map((t, i) => /*#__PURE__*/React.createElement("div", {
    key: t,
    style: {
      ...pad,
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...li,
      flex: 1,
      borderTop: i ? '1px solid var(--color-border)' : 'none',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 'none',
      width: 26,
      height: 26,
      borderRadius: '50%',
      border: '1px solid var(--color-border-strong)',
      color: 'var(--color-text-muted)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "x",
    size: 14,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("span", null, t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      ...pad,
      paddingBottom: pv
    }
  }))));
};
Object.assign(window, {
  Section,
  SectionHead,
  ProofRow,
  UsVsThem,
  HeroFilm
});
;
function Homepage(_ref) {
  var {
    go,
    onCart
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroFilm, {
    page: "home"
  }), /*#__PURE__*/React.createElement(Hero, {
    onPrimary: () => go('/create/'),
    onSecondary: () => go('/how-it-works/')
  }), /*#__PURE__*/React.createElement(HowItWorksTimeline, {
    tone: "white",
    style: {
      paddingBottom: 0
    }
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "5/7",
    eyebrow: "See the Difference",
    heading: "Not just converted. Carefully refined.",
    body: "Drag to compare the original photograph with the finished One Print Gallery transformation. We focus on recognisable faces, clothing, places and details so the page still feels like your memory.",
    linkLabel: "See more transformations",
    linkHref: "/gallery/",
    media: /*#__PURE__*/React.createElement(BeforeAfterSlider, {
      ratio: "4 / 5"
    })
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '7fr 5fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-thumbs": "",
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/mockups/luna-flatlay.webp"),
    alt: "Adventures of Luna open on a desk beside its cover",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: '16px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/transform/family-after.webp"),
    alt: "A finished line-art page from a personalised book",
    style: {
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/transform/colouring-after.webp"),
    alt: "Line-art detail from a finished page",
    style: {
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      maxWidth: '20ch'
    }
  }, "A colouring book nobody else could own."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '22px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '46ch'
    }
  }, "Every page starts with your photographs, turning familiar people and places into a creative activity that becomes a keepsake in its own right."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-6) 0 0',
      display: 'flex',
      alignItems: 'baseline',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, "From"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-2xl)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, "\xA314.99")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '12px',
      marginTop: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/product/')
  }, "Start Personalising"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "lg",
    onClick: () => go('/product/')
  }, "See the Book"))))), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "7/5",
    reverse: true,
    eyebrow: "Old Photos Welcome",
    heading: "Faded, creased, forty years old. Still perfect.",
    body: "This wedding photo was snapped on a phone, glare and all, straight off the mantelpiece. Line art doesn't need a flawless original. Send the photos you love and we'll bring out the faces, the lace and the flowers.",
    linkLabel: "Photo guidance",
    linkHref: "/how-it-works/",
    media: /*#__PURE__*/React.createElement(BeforeAfterSlider, {
      ratio: "4 / 5",
      beforeSrc: OPG_A("../../assets/web/transform/wedding-before-aligned.webp"),
      afterSrc: OPG_A("../../assets/web/transform/wedding-after-aligned.webp")
    })
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "paper",
    split: "7/5",
    eyebrow: "New \xB7 Colouring Photo Album",
    heading: "Keep the photograph. Colour it too.",
    body: "Every spread pairs your original photo, with names or a caption underneath, beside its matching colouring page. Part photo album, part colouring book. A4 or A5, coil bound or hardback, from \xA324.99.",
    linkLabel: "See the Photo Album",
    linkHref: "/photo-album/",
    imageSrc: OPG_A("../../assets/web/mockups/luna-before-after.webp")
  }), /*#__PURE__*/React.createElement(TestimonialFeature, {
    tone: "navy"
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "7/5",
    reverse: true,
    eyebrow: "Why One Print Gallery",
    heading: "Personalised should mean more than a name on a template.",
    points: [{
      title: 'Real memories',
      body: 'Your photographs create the content. We never drop a name into a stock template.'
    }, {
      title: 'Recognisable style',
      body: 'Realistic, clean line-art that preserves meaningful detail rather than forcing every photograph into a cartoon look.'
    }, {
      title: 'Human care',
      body: 'Every order is treated as a personal project, with support available when you need it.'
    }],
    imageSrc: OPG_A("../../assets/web/transform/baby-cat-after.webp")
  }), /*#__PURE__*/React.createElement(UsVsThem, {
    tone: "paper",
    onCta: () => go('/create/')
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Transformation Gallery",
    heading: "Photo in. Keepsake out.",
    body: "A curated selection of finished projects. Each one begins with a customer's own photographs, shown with their permission."
  }), /*#__PURE__*/React.createElement("ul", {
    "data-opg-six": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(6,minmax(0,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, [{
    t: 'Our wedding day',
    f: 'jade-wedding-after.webp'
  }, {
    t: 'Three generations on the sofa',
    f: 'jade-family-after.webp'
  }, {
    t: 'Their wedding day, forty years on',
    f: 'wedding-after.webp'
  }, {
    t: 'The whole family, cat included',
    f: 'family-after.webp'
  }, {
    t: 'Colouring at the dining table',
    f: 'colouring-after.webp'
  }, {
    t: 'Saturday morning football',
    f: 'football-after.webp'
  }].map(_ref2 => {
    var {
      t,
      f
    } = _ref2;
    return /*#__PURE__*/React.createElement("li", {
      key: t
    }, /*#__PURE__*/React.createElement("img", {
      loading: "lazy",
      decoding: "async",
      src: OPG_A('../../assets/web/transform/') + f,
      alt: t,
      style: {
        width: '100%',
        aspectRatio: '4 / 5',
        objectFit: 'cover',
        borderRadius: 'var(--radius-md)',
        border: '1px solid var(--color-border)',
        background: 'var(--opg-white)'
      }
    }), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: '14px 0 0',
        fontFamily: 'var(--font-display)',
        fontWeight: 600,
        fontSize: 'var(--text-lg)',
        color: 'var(--color-brand)'
      }
    }, t));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(TextLink, {
    href: "/gallery/",
    withArrow: true
  }, "See the full gallery"))), /*#__PURE__*/React.createElement(Manifesto, null), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "One of One",
    heading: "Original art, printed to order.",
    body: "Two collections designed by One Print Gallery: the Highland Cows and The Obsidian Society. Premium posters in four sizes, from \xA319.99."
  }), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Art Print",
    price: "\xA319.99",
    priceFrom: true,
    medium: "12 \xD7 18 to 24 \xD7 36 in",
    title: "See No Evil",
    collection: "Highland Cows",
    imageSrc: OPG_A("../../assets/web/art/see-no-evil.webp"),
    ratio: "2 / 3",
    href: opgArtHref("See No Evil", "Highland Cows")
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Art Print",
    price: "\xA319.99",
    priceFrom: true,
    medium: "12 \xD7 18 to 24 \xD7 36 in",
    title: "Hear No Evil",
    collection: "Highland Cows",
    imageSrc: OPG_A("../../assets/web/art/hear-no-evil.webp"),
    ratio: "2 / 3",
    href: opgArtHref("Hear No Evil", "Highland Cows")
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Art Print",
    price: "\xA319.99",
    priceFrom: true,
    medium: "12 \xD7 18 to 24 \xD7 36 in",
    title: "The Detective",
    collection: "The Obsidian Society",
    imageSrc: OPG_A("../../assets/web/art/obsidian-the-detective.webp"),
    ratio: "2 / 3",
    href: opgArtHref("The Detective", "The Obsidian Society")
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Art Print",
    price: "\xA319.99",
    priceFrom: true,
    medium: "12 \xD7 18 to 24 \xD7 36 in",
    title: "The Boss",
    collection: "The Obsidian Society",
    imageSrc: OPG_A("../../assets/web/art/obsidian-the-boss.webp"),
    ratio: "2 / 3",
    href: opgArtHref("The Boss", "The Obsidian Society")
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: () => go('/art-collection/')
  }, "Explore the Art Collection"))), /*#__PURE__*/React.createElement(FounderFeature, null), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    heading: "Made for more than one kind of customer.",
    body: "We also develop bespoke colouring, keepsake and creative projects for schools, SEN settings, care homes, football clubs and organisations."
  }), /*#__PURE__*/React.createElement(AudienceSelector, null)), /*#__PURE__*/React.createElement(window.OPG_Slot, { name: "reviews" }), /*#__PURE__*/React.createElement(FaqAccordion, {
    tone: "paper"
  }), /*#__PURE__*/React.createElement(FullBleedBanner, {
    align: "center",
    heading: "Your next keepsake is already in your camera roll.",
    ctaLabel: "Create Your Book",
    ctaHref: "/create/",
    secondaryLabel: "See How It Works",
    secondaryHref: "/how-it-works/"
  }));
}
Object.assign(window, {
  Homepage
});
;
function ProductPage(_ref) {
  var {
    go
  } = _ref;
  var [main, setMain] = React.useState(0);
  var media = [{
    src: OPG_A('../../assets/web/mockups/luna-held.webp'),
    note: 'In hand',
    fit: 'cover'
  }, {
    src: OPG_A('../../assets/web/mockups/luna-flatlay.webp'),
    note: 'Open spread',
    fit: 'cover'
  }, {
    src: OPG_A('../../assets/web/mockups/luna-before-after.webp'),
    note: 'Photo beside its page',
    fit: 'cover'
  }, {
    src: OPG_A('../../assets/web/books/luna-front.webp'),
    note: 'Front cover',
    fit: 'contain'
  }, {
    src: OPG_A('../../assets/web/books/luna-back.webp'),
    note: 'Back cover',
    fit: 'contain'
  }, {
    src: OPG_A('../../assets/web/transform/colouring-after.webp'),
    note: 'Interior page',
    fit: 'cover'
  }, {
    src: OPG_A('../../assets/web/transform/colouring-before.webp'),
    note: 'Source photograph',
    fit: 'cover'
  }];
  var narrow = useOpgMQ('(max-width:1024px)');
  var cta = () => go('/create/');
  var carousel = React.createElement(ProductCarousel, { media: media });
  var slider = React.createElement(BeforeAfterSlider, { ratio: "4 / 5" });
  return React.createElement(React.Fragment, null, React.createElement(HeroFilm, {
    page: "colouring"
  }), React.createElement(Section, {
    tone: "white",
    pad: "standard",
    style: { paddingTop: 'clamp(24px,4vw,56px)' }
  }, narrow ? React.createElement("div", { style: { display: 'grid', gap: 'var(--space-6)' } },
    React.createElement(PriceOptionsPanel, { part: "head" }), carousel, React.createElement(PriceOptionsPanel, { part: "options", onCta: cta }), slider)
  : React.createElement("div", { style: { display: 'grid', gridTemplateColumns: '60fr 40fr', gap: 'var(--space-8) var(--grid-gap-xl)', alignItems: 'start' } },
    React.createElement("div", { style: { minWidth: 0, display: 'grid', gap: 'var(--space-6)' } }, carousel, slider),
    React.createElement("div", { "data-opg-sticky": "", style: { minWidth: 0, position: 'sticky', top: 'calc(var(--header-height) + 24px)' } }, React.createElement(PriceOptionsPanel, { onCta: cta })))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "How It Works",
    heading: "Your photographs become the pages."
  }), /*#__PURE__*/React.createElement(TransformationTriptych, null)), /*#__PURE__*/React.createElement(UsVsThem, {
    tone: "white",
    onCta: () => go('/create/')
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "7/5",
    eyebrow: "Photo Guidance",
    heading: "Any photo works. Send your favourites.",
    body: "Phone snaps, slightly blurred shots, old prints, even decades-old pictures. They all come out really well as colouring pages, because blur, grain and faded colour disappear in line-art. No need to hunt for the perfect, highest-quality file. Choose the moments that matter and we will take care of the rest.",
    linkLabel: "Read the full photo guide",
    linkHref: "/how-it-works/",
    imageSrc: OPG_A("../../assets/web/mockups/luna-before-after.webp"),
    reverse: true
  }), /*#__PURE__*/React.createElement(TestimonialFeature, {
    tone: "blush",
    showMedia: false
  }), /*#__PURE__*/React.createElement(window.OPG_Slot, { name: "reviews" }), /*#__PURE__*/React.createElement(FaqAccordion, {
    heading: "Questions before you order"
  }), /*#__PURE__*/React.createElement(StickyProductCTA, {
    onCta: () => go('/create/')
  }));
}
function HowItWorksPage(_ref2) {
  var {
    go
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FullBleedBanner, {
    heading: "From your camera roll to their colouring book.",
    body: "Every book begins with photographs you already love. Here is exactly what happens between your upload and the finished keepsake.",
    height: "clamp(380px,48vh,560px)",
    level: 1
  }), /*#__PURE__*/React.createElement(HowItWorksTimeline, {
    tone: "white",
    eyebrow: "The Process",
    heading: "Five steps, and we handle the difficult one."
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Photo Guidance",
    heading: "Any photo works. Send your favourites.",
    body: "You do not need professional or perfect photographs. Line-art is forgiving, so choose the moments that mean something rather than the sharpest file."
  }), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 'var(--grid-gap-xl)'
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      alignContent: 'start',
      gap: '12px'
    }
  }, ['Phone photos, straight from your camera roll', 'Slightly blurred or out-of-focus shots', 'Old prints (just snap them with your phone)', 'Faded, grainy or decades-old pictures', 'Busy backgrounds and everyday moments'].map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'flex',
      gap: 11,
      paddingBottom: 12,
      borderBottom: '1px solid var(--color-border)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-base)',
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-success)',
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    size: 17
  })), t))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/mockups/luna-before-after.webp"),
    alt: "An everyday phone photo printed beside its finished colouring page",
    style: {
      width: '100%',
      aspectRatio: '4 / 5',
      objectFit: 'cover',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--color-border)',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '16px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)'
    }
  }, "Not sure about one? Send it anyway. If a photo ever needs a second look, we will get in touch before anything is printed.")))), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "5/7",
    eyebrow: "The Standard",
    heading: "Not a cartoon filter. A keepsake.",
    body: "Automatic photo-to-line-art apps tend to give generic, cartoon-like results. Every One Print Gallery page is refined and checked by a person, so faces, clothing and places still look like the real thing.",
    media: /*#__PURE__*/React.createElement(BeforeAfterSlider, {
      ratio: "4 / 5"
    })
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "paper",
    split: "7/5",
    reverse: true,
    heading: "Request a preview before print",
    body: "If you would like to see your book before it is printed, choose the preview option during personalisation. Requesting a preview may affect production timing, as books are normally made to order in 2\u20134 business days.",
    ctaLabel: "Create Your Book",
    ctaHref: "/create/",
    imageSrc: OPG_A("../../assets/web/transform/football-after.webp")
  }), /*#__PURE__*/React.createElement(FaqAccordion, {
    tone: "white"
  }), /*#__PURE__*/React.createElement(FullBleedBanner, {
    align: "center",
    heading: "Your next keepsake is already in your camera roll.",
    ctaLabel: "Create Your Book",
    ctaHref: "/create/"
  }));
}
var {
  PriceOptionsPanel,
  StickyProductCTA,
  Icon
} = window.OnePrintGalleryDesignSystem_ba4735;
Object.assign(window, {
  ProductPage,
  HowItWorksPage
});
;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function OneOfOneArtPage(_ref) {
  var {
    go
  } = _ref;
  var [filter, setFilter] = React.useState('All work');
  var A = OPG_A('../../assets/web/art/');
  var P = window.OnePrintGalleryDesignSystem_ba4735.ART_PRINTS;
  var works = [{
    title: 'See No Evil',
    collection: 'Highland Cows',
    imageSrc: A + 'see-no-evil.webp'
  }, {
    title: 'Hear No Evil',
    collection: 'Highland Cows',
    imageSrc: A + 'hear-no-evil.webp'
  }, {
    title: 'Speak No Evil',
    collection: 'Highland Cows',
    imageSrc: A + 'speak-no-evil.webp'
  }, {
    title: 'The Boss',
    collection: 'The Obsidian Society',
    medium: 'No. I',
    imageSrc: A + 'obsidian-the-boss.webp'
  }, {
    title: 'Boardroom',
    collection: 'The Obsidian Society',
    medium: 'No. II',
    imageSrc: A + 'obsidian-boardroom.webp'
  }, {
    title: 'The Detective',
    collection: 'The Obsidian Society',
    medium: 'No. III',
    imageSrc: A + 'obsidian-the-detective.webp'
  }, {
    title: 'The Strategist',
    collection: 'The Obsidian Society',
    medium: 'No. IV',
    imageSrc: A + 'obsidian-the-strategist.webp'
  }, {
    title: 'The Assassin',
    collection: 'The Obsidian Society',
    medium: 'No. V',
    imageSrc: A + 'obsidian-the-assassin.webp'
  }].map(w => ({
    status: 'available',
    ratio: '2 / 3',
    badge: 'Art Print',
    price: P.from,
    priceFrom: true,
    ...w,
    medium: (w.medium && w.medium.startsWith('No.') ? w.medium + ' · ' : '') + P.sizeRange
  }));
  var CA = (window.OPG && OPG.customArt) || [];
  var jump = id => { var el = document.getElementById(id); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' }); };
  var shown = filter === 'All work' ? works : works.filter(w => w.collection === filter);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      position: 'relative',
      width: '100%',
      aspectRatio: '16 / 9',
      overflow: 'hidden',
      background: '#fff'
    }
  }, /*#__PURE__*/React.createElement("video", {
    src: window.OPG && OPG.video || "",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    preload: "auto",
    tabIndex: -1,
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
      pointerEvents: 'none'
    }
  })), /*#__PURE__*/React.createElement(Hero, {
    tone: "ink",
    split: "7/5",
    eyebrow: null,
    heading: "Art for your walls.",
    body: "Original One-of-One prints from our own collections, and custom pieces made from your photos.",
    primaryLabel: "Shop One-of-One Art",
    onPrimary: () => jump('one-of-one'),
    secondaryLabel: "Create Custom Art",
    onSecondary: () => jump('custom-art'),
    makerLine: null,
    imageSrc: OPG_A("../../assets/web/art/speak-no-evil.webp"),
    ratio: "2 / 3"
  }), /*#__PURE__*/React.createElement("div", {
    id: "one-of-one"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "One of One",
    heading: "Original art, printed to order.",
    body: "Two collections designed by One Print Gallery, the Highland Cows and The Obsidian Society, printed on premium 200gsm silk paper in four sizes."
  }), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '8fr 4fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/art/highland-trio.webp"),
    alt: "See, Hear, Speak No Evil: three Highland calves",
    style: {
      width: '100%',
      aspectRatio: '3 / 2',
      objectFit: 'cover',
      display: 'block',
      background: 'var(--opg-white)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    tone: "edition"
  }, "Featured Collection"), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: '18px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontStyle: 'italic',
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      color: 'var(--color-brand)'
    }
  }, "See, Hear, Speak No Evil"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '12px 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "Highland Cows \xB7 Three posters, sold individually"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '22px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.7,
      color: 'var(--color-text-muted)',
      maxWidth: '44ch'
    }
  }, "Three Highland calves, each covering eyes, ears or mouth. A gentle take on the Three Wise Monkeys, drawn in detailed pencil style with a soft sketch-fade border. Beautiful alone, better as a set."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'var(--space-6) 0 0',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-2xl)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)',
      marginRight: 10
    }
  }, "From"), P.from), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '6px 0 0',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "Each poster ", P.sizeRange, " \xB7 ", P.delivery), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/one-of-one-art/highland-cows/')
  }, "See the Collection")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '16px 0 0',
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, P.paper, ". ", P.note)))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      marginBottom: 'var(--space-7)'
    }
  }, ['All work', 'Highland Cows', 'The Obsidian Society'].map(f => /*#__PURE__*/React.createElement("button", {
    key: f,
    type: "button",
    onClick: () => setFilter(f),
    style: {
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Tag, {
    tone: filter === f ? 'brand' : 'neutral'
  }, f)))), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(230px,1fr))',
      gap: 'var(--space-8) var(--grid-gap-lg)'
    }
  }, shown.map(w => /*#__PURE__*/React.createElement("li", {
    key: w.title
  }, /*#__PURE__*/React.createElement(ArtworkCard, _extends({}, w, {
    href: opgArtHref(w.title, w.collection)
  })))))), /*#__PURE__*/React.createElement(Manifesto, {
    tone: "navy",
    caps: false,
    heading: "Collect one, or assemble the set.",
    body: "Every piece is designed to hang alone or as part of its collection: three Highland calves, or all five members of The Obsidian Society."
  }), /*#__PURE__*/React.createElement(EditorialSplit, {
    tone: "white",
    split: "5/7",
    eyebrow: "Print Details",
    heading: "Made to hang for years.",
    points: [{
      title: 'Four sizes',
      body: P.sizes.map(s => s.title + ': ' + s.price).join(' · ')
    }, {
      title: 'Premium paper',
      body: '200gsm semi-gloss silk, printed with UV inks for deep blacks and crisp detail.'
    }, {
      title: 'Frame not included',
      body: 'Sized to standard frames so it drops straight in.'
    }],
    imageSrc: OPG_A("../../assets/web/art/obsidian-society.webp"),
    reverse: true
  }), /*#__PURE__*/React.createElement("div", {
    id: "custom-art"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Custom Art",
    heading: "Your photos, made into art.",
    body: "Choose a style, upload up to 3 photos and add a name or message. Each piece is made to order and delivered within 7 working days."
  }), /*#__PURE__*/React.createElement("ol", {
    style: { listStyle: 'none', margin: '0 0 var(--space-8)', padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 'var(--space-5) var(--grid-gap-lg)' }
  }, /*#__PURE__*/React.createElement("li", {
    style: { display: 'grid', gap: 6, alignContent: 'start', paddingTop: 'var(--space-4)', borderTop: '1px solid var(--color-border)' }
  }, /*#__PURE__*/React.createElement("span", { style: { fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', fontWeight: 700, letterSpacing: '0.08em', color: 'var(--color-accent-strong, var(--color-brand))' } }, "01"), /*#__PURE__*/React.createElement("strong", { style: { fontFamily: 'var(--font-display)', fontSize: 'var(--text-xl)', fontWeight: 600, color: 'var(--color-brand)' } }, "Choose a style"), /*#__PURE__*/React.createElement("span", { style: { fontSize: 'var(--text-sm)', lineHeight: 1.6, color: 'var(--color-text-muted)' } }, "Pick a custom piece and a size.")), /*#__PURE__*/React.createElement("li", {
    style: { display: 'grid', gap: 6, alignContent: 'start', paddingTop: 'var(--space-4)', borderTop: '1px solid var(--color-border)' }
  }, /*#__PURE__*/React.createElement("span", { style: { fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', fontWeight: 700, letterSpacing: '0.08em', color: 'var(--color-accent-strong, var(--color-brand))' } }, "02"), /*#__PURE__*/React.createElement("strong", { style: { fontFamily: 'var(--font-display)', fontSize: 'var(--text-xl)', fontWeight: 600, color: 'var(--color-brand)' } }, "Upload up to 3 photos"), /*#__PURE__*/React.createElement("span", { style: { fontSize: 'var(--text-sm)', lineHeight: 1.6, color: 'var(--color-text-muted)' } }, "Add the photos, plus any name or text up to 60 characters.")), /*#__PURE__*/React.createElement("li", {
    style: { display: 'grid', gap: 6, alignContent: 'start', paddingTop: 'var(--space-4)', borderTop: '1px solid var(--color-border)' }
  }, /*#__PURE__*/React.createElement("span", { style: { fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', fontWeight: 700, letterSpacing: '0.08em', color: 'var(--color-accent-strong, var(--color-brand))' } }, "03"), /*#__PURE__*/React.createElement("strong", { style: { fontFamily: 'var(--font-display)', fontSize: 'var(--text-xl)', fontWeight: 600, color: 'var(--color-brand)' } }, "Delivered in 7 working days"), /*#__PURE__*/React.createElement("span", { style: { fontSize: 'var(--text-sm)', lineHeight: 1.6, color: 'var(--color-text-muted)' } }, "We create and print your piece, then post it to you."))), CA.length ? /*#__PURE__*/React.createElement("ul", {
    style: { listStyle: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(230px,1fr))', gap: 'var(--space-8) var(--grid-gap-lg)' }
  }, CA.map(w => /*#__PURE__*/React.createElement("li", { key: w.u }, /*#__PURE__*/React.createElement(ArtworkCard, {
    badge: "Custom",
    status: "available",
    title: w.t,
    collection: "Custom Art",
    medium: "Made from your photos",
    price: w.p,
    priceFrom: !!w.v,
    imageSrc: w.i || undefined,
    ratio: "4 / 5",
    href: w.u
  })))) : /*#__PURE__*/React.createElement("p", {
    style: { margin: 0, fontSize: 'var(--text-base)', lineHeight: 1.7, color: 'var(--color-text-muted)' }
  }, "New custom pieces are on their way. ", /*#__PURE__*/React.createElement(TextLink, { href: "#", onClick: e => { e.preventDefault(); go('/contact/'); } }, "Ask us about a custom piece"))));
}
Object.assign(window, {
  OneOfOneArtPage
});
;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function PhotoAlbumPage(_ref) {
  var go = _ref.go;
  var DS = window.OnePrintGalleryDesignSystem_ba4735;
  var A = DS.PHOTO_ALBUM;
  var StickyProductCTA = DS.StickyProductCTA;
  var h = React.createElement;
  var saved = opgPick('album');
  var counts = A.pages.map(p => p.count);
  var [pages, setPages] = React.useState(counts.indexOf(saved.pages) > -1 ? saved.pages : counts[0]);
  var [binding, setBinding] = React.useState(saved.binding === 'hardback' ? 'hardback' : 'coil');
  var [size, setSize] = React.useState(saved.size === 'a5' ? 'a5' : 'a4');
  var [main, setMain] = React.useState(0);
  React.useEffect(() => { opgPick('album', { pages, binding, size }); }, [pages, binding, size]);
  var price = A.priceFor({ pages, binding, size });
  var img = n => OPG_A('../../assets/web/album/' + n + '.webp');
  var media = [
    { src: img('album-photo-and-colouring'), note: 'Photo album & colouring book in one', short: 'In one', fit: 'cover' },
    { src: img('album-a4-a5'), note: 'Available in A4 and A5', short: 'A4 & A5', fit: 'contain' },
    { src: img('album-coil-spreads'), note: 'Coil bound, opens flat for colouring', short: 'Coil', fit: 'cover' },
    { src: img('album-hardback-spreads'), note: 'Hardback, a premium photo-album finish', short: 'Hardback', fit: 'cover' },
    { src: img('album-photo-left'), note: 'Actual photo left, colouring page right', short: 'Spread', fit: 'cover' }
  ];
  var serif = { fontFamily: 'var(--font-display)', fontStyle: 'italic', fontWeight: 500 };
  var label = { margin: '0 0 10px', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', fontWeight: 700, letterSpacing: 'var(--tracking-eyebrow)', textTransform: 'uppercase', color: 'var(--color-text-muted)' };
  var opt = on => ({ display: 'grid', gap: 2, alignContent: 'start', textAlign: 'left', padding: '12px 14px', minHeight: 52, cursor: 'pointer', background: on ? 'var(--opg-navy-900)' : 'var(--opg-white)', color: on ? 'var(--opg-white)' : 'var(--color-text)', border: '1.5px solid ' + (on ? 'var(--opg-navy-900)' : 'var(--color-border-strong)'), borderRadius: 'var(--radius-sm)', fontFamily: 'var(--font-sans)', transition: 'background var(--motion-fast), border-color var(--motion-fast)' });
  var optSub = on => ({ fontSize: 'var(--text-xs)', lineHeight: 1.4, color: on ? 'var(--color-text-on-dark-muted)' : 'var(--color-text-muted)' });
  var Opt = p => h('button', { type: 'button', onClick: p.onClick, 'aria-pressed': p.on, style: opt(p.on) },
    h('span', { style: { display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: 'var(--text-sm)', fontWeight: 700 } }, h('span', null, p.title), p.extra ? h('span', { style: { fontWeight: 600, color: p.on ? 'var(--opg-peach-300)' : 'var(--color-accent-warm)' } }, p.extra) : null),
    p.meta ? h('span', { style: optSub(p.on) }, p.meta) : null);
  var startCreate = () => { opgPick('album', { pages, binding, size }); go('/photo-album/create-your-album/'); };
  var scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  var m = media[main];
  var spreadW = size === 'a5' ? '76%' : '100%';
  var hard = binding === 'hardback';

  var page1 = h(Section, { tone: 'ink', pad: 'standard' },
    h('div', { 'data-opg-split': '', style: { display: 'grid', gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)', gap: 'var(--space-7) var(--grid-gap-xl)', alignItems: 'start' } },
      h('div', { 'data-opg-sticky': '', style: { minWidth: 0, display: 'grid', gap: 'var(--space-5)', position: 'sticky', top: 'calc(var(--header-height) + 24px)' } },
        h('figure', { style: { margin: 0, display: 'grid', gap: 14 } },
          h('div', { style: { background: 'var(--opg-white)', padding: 'clamp(8px,1.1vw,14px)', borderRadius: 4, boxShadow: '0 40px 70px -40px rgba(0,0,0,.75)' } },
            h('img', { decoding: 'async', src: m.src, alt: m.note, style: { display: 'block', width: '100%', aspectRatio: '4 / 3', objectFit: m.fit, background: 'var(--opg-paper)' } })),
          h('figcaption', { style: Object.assign({}, serif, { margin: 0, fontSize: 'var(--text-xl)', color: 'var(--opg-white)', textAlign: 'center' }) }, m.note)),
        h('ul', { style: { listStyle: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(5,minmax(0,1fr))', gap: 'clamp(8px,1.4vw,16px)' } },
          media.map((x, i) => h('li', { key: i, style: { minWidth: 0 } },
            h('button', { type: 'button', onClick: () => setMain(i), 'aria-label': x.note, 'aria-current': i === main, style: { display: 'grid', gap: 4, width: '100%', padding: '5px 5px 6px', background: 'var(--opg-white)', border: 0, borderRadius: 2, cursor: 'pointer', transform: i === main ? 'translateY(-4px)' : 'rotate(' + (i % 2 ? 2 : -2) + 'deg)', boxShadow: i === main ? '0 0 0 2px var(--opg-peach-300)' : '0 10px 20px -12px rgba(0,0,0,.7)', transition: 'transform var(--motion-base) var(--ease-standard)' } },
              h('img', { loading: 'lazy', decoding: 'async', src: x.src, alt: '', style: { display: 'block', width: '100%', aspectRatio: '1 / 1', objectFit: 'cover' } }),
              h('span', { style: Object.assign({}, serif, { fontSize: 'clamp(11px,1.1vw,15px)', lineHeight: 1.1, color: 'var(--opg-navy-700)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }) }, x.short)))))),
      h('div', { style: { minWidth: 0, background: 'var(--opg-paper)', color: 'var(--color-text)', borderRadius: 'var(--radius-lg)', padding: 'clamp(22px,3vw,36px)', display: 'grid', gap: 'var(--space-5)' } },
        h('div', null,
          h('h1', { style: { margin: 0, fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 'var(--text-3xl)', lineHeight: 1.02, letterSpacing: 'var(--tracking-display)', color: 'var(--color-brand)' } }, A.title),
          h('p', { style: Object.assign({}, serif, { margin: '10px 0 0', fontSize: 'var(--text-xl)', lineHeight: 1.25, color: 'var(--opg-burgundy-600)' }) }, 'Actual photo left \xB7 colouring page right')),
        h('div', { 'aria-hidden': 'true', style: { display: 'grid', justifyItems: 'center', padding: '18px 12px', background: 'var(--opg-white)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)' } },
          h('div', { style: { width: spreadW, maxWidth: 340, display: 'grid', gridTemplateColumns: '1fr ' + (hard ? '4px' : '10px') + ' 1fr', padding: hard ? 5 : 0, background: hard ? 'var(--opg-navy-900)' : 'transparent', borderRadius: 4, boxShadow: '0 14px 26px -18px rgba(20,28,60,.6)', transition: 'width var(--motion-slow) var(--ease-editorial)' } },
            h('div', { style: { background: '#fff', padding: '8% 8% 4%', display: 'grid', gap: 4, border: '1px solid var(--color-border)' } },
              h('img', { loading: 'lazy', decoding: 'async', src: OPG_A('../../assets/web/transform/family-before.webp'), alt: '', style: { display: 'block', width: '100%', aspectRatio: '1 / 1', objectFit: 'cover' } }),
              h('span', { style: Object.assign({}, serif, { fontSize: 12, textAlign: 'center', color: 'var(--opg-navy-700)' }) }, 'Your caption \u2661')),
            h('span', { style: { background: hard ? 'var(--opg-navy-900)' : 'repeating-linear-gradient(180deg,var(--opg-stone) 0 3px,transparent 3px 7px)', backgroundSize: hard ? 'auto' : '4px 100%', backgroundRepeat: 'repeat-y', backgroundPosition: 'center' } }),
            h('div', { style: { background: '#fff', padding: '8% 8% 4%', display: 'grid', alignContent: 'start', border: '1px solid var(--color-border)' } },
              h('img', { loading: 'lazy', decoding: 'async', src: OPG_A('../../assets/web/transform/family-after.webp'), alt: '', style: { display: 'block', width: '100%', aspectRatio: '1 / 1', objectFit: 'cover' } }))),
          h('p', { style: { margin: '12px 0 0', fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)', textAlign: 'center' } }, (size === 'a5' ? 'A5' : 'A4') + ' \xB7 ' + (hard ? 'Hardback' : 'Coil bound') + ' \xB7 ' + pages + ' spreads')),
        h('div', null, h('p', { style: label }, 'Size'),
          h('div', { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 } },
            h(Opt, { on: size === 'a4', onClick: () => setSize('a4'), title: 'A4', extra: '+\xA35', meta: '21 \xD7 29.7 cm' }),
            h(Opt, { on: size === 'a5', onClick: () => setSize('a5'), title: 'A5', meta: '14.8 \xD7 21 cm' }))),
        h('div', null, h('p', { style: label }, 'Binding'),
          h('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 8 } },
            A.bindings.map(b => h(Opt, { key: b.id, on: binding === b.id, onClick: () => setBinding(b.id), title: b.title, extra: b.id === 'hardback' ? '+\xA310' : null, meta: b.description })))),
        h('div', null, h('p', { style: label }, 'Photo spreads'),
          h('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(' + counts.length + ',minmax(0,1fr))', gap: 6 } },
            counts.map(n => h('button', { key: n, type: 'button', onClick: () => setPages(n), 'aria-pressed': pages === n, style: { minHeight: 48, padding: 0, cursor: 'pointer', borderRadius: 'var(--radius-round)', border: '1.5px solid ' + (pages === n ? 'var(--opg-navy-900)' : 'var(--color-border-strong)'), background: pages === n ? 'var(--opg-navy-900)' : 'var(--opg-white)', color: pages === n ? 'var(--opg-white)' : 'var(--color-text)', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', fontWeight: 700 } }, n))),
          h('p', { style: { margin: '8px 0 0', fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)' } }, pages + ' photos + ' + pages + ' matching colouring pages')),
        h('div', { style: { paddingTop: 'var(--space-5)', borderTop: '1px solid var(--color-border-strong)', display: 'grid', gap: 14 } },
          h('p', { style: { margin: 0, display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12 } },
            h('span', { style: { fontFamily: 'var(--font-sans)', fontSize: 'var(--text-2xl)', fontWeight: 700, color: 'var(--color-text)' } }, '\xA3' + price),
            h('span', { style: { fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)', textAlign: 'right' } }, A.delivery)),
          h(Button, { variant: 'primary', size: 'lg', onClick: startCreate, style: { width: '100%' } }, 'Personalise Your Album'),
          h('p', { style: { margin: 0, fontSize: 'var(--text-xs)', lineHeight: 1.6, color: 'var(--color-text-muted)' } }, 'Next you\u2019ll upload your photos, add a caption for each one and a title for the cover. ', DS.FULFILMENT.uploadLimit)))));

  var spread = h(Section, { tone: 'paper' },
    h('div', { 'data-opg-split': '', style: { display: 'grid', gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)', gap: 'var(--space-7) var(--grid-gap-xl)', alignItems: 'center' } },
      h('img', { loading: 'lazy', decoding: 'async', src: img('album-coil-spreads'), alt: 'Two open coil-bound albums: a photo with its caption on the left, its colouring page on the right', style: { width: '100%', aspectRatio: '4 / 3', objectFit: 'cover', borderRadius: 'var(--radius-md)' } }),
      h('div', { style: { minWidth: 0 } },
        h(SectionHead, { heading: 'Every memory, told twice.' }),
        h('ol', { style: { listStyle: 'none', margin: 'calc(var(--space-6) * -1) 0 0', padding: 0, display: 'grid' } },
          [['Left page', 'Your original photograph, printed in full colour.'], ['Underneath', 'The names or a short caption, written in a soft script.'], ['Right page', 'The same moment redrawn as detailed line art, ready to colour.']].map((s, i) => h('li', { key: s[0], style: { display: 'grid', gridTemplateColumns: '48px minmax(0,1fr)', gap: 14, padding: '18px 0', borderBottom: '1px solid var(--color-border-strong)' } },
            h('span', { style: Object.assign({}, serif, { fontSize: 'var(--text-3xl)', lineHeight: .9, fontVariantNumeric: 'lining-nums', color: 'var(--color-accent-warm)' }) }, i + 1),
            h('span', null, h('strong', { style: { display: 'block', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--color-brand)' } }, s[0]), h('span', { style: { display: 'block', marginTop: 4, fontSize: 'var(--text-sm)', lineHeight: 1.6, color: 'var(--color-text-muted)' } }, s[1]))))))));

  var specs = [['A4', '21 \xD7 29.7 cm', 'Bigger photos and more detail to colour.', '+\xA35'], ['A5', '14.8 \xD7 21 cm', 'Compact, easy to hold and to post.', 'From \xA3' + A.priceFor({ pages: 10, binding: 'coil', size: 'a5' })], ['Coil bound', 'Opens flat', 'Lies flat on the table while you colour.', 'Included'], ['Hardback', 'Photo-album finish', 'A sturdier keepsake for the bookshelf.', '+\xA310']];
  var formats = h(Section, { tone: 'white' },
    h('div', { 'data-opg-split': '', style: { display: 'grid', gridTemplateColumns: 'minmax(0,5fr) minmax(0,7fr)', gap: 'var(--space-7) var(--grid-gap-xl)', alignItems: 'center' } },
      h('img', { loading: 'lazy', decoding: 'async', src: img('album-a4-a5'), alt: 'A4 and A5 colouring photo albums side by side', style: { width: '100%', aspectRatio: '1149 / 1369', objectFit: 'cover', borderRadius: 'var(--radius-md)' } }),
      h('div', { style: { minWidth: 0 } },
        h(SectionHead, { heading: 'Two sizes. Two finishes.', body: 'Mix and match. Every option has the same layout inside: photo on the left, colouring page on the right.' }),
        h('ul', { 'data-opg-cols': '', style: { listStyle: 'none', margin: 'calc(var(--space-4) * -1) 0 0', padding: 0, display: 'grid', gridTemplateColumns: 'repeat(2,minmax(0,1fr))', gap: 'var(--space-6) var(--grid-gap-lg)' } },
          specs.map(s => h('li', { key: s[0], style: { paddingTop: 'var(--space-4)', borderTop: '2px solid var(--opg-navy-900)', display: 'grid', gap: 4 } },
            h('span', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 } }, h('strong', { style: { fontFamily: 'var(--font-display)', fontSize: 'var(--text-2xl)', fontWeight: 600, color: 'var(--color-brand)' } }, s[0]), h('span', { style: { fontSize: 'var(--text-xs)', fontWeight: 700, color: 'var(--color-accent-warm)' } }, s[3])),
            h('span', { style: { fontSize: 'var(--text-xs)', fontWeight: 700, letterSpacing: 'var(--tracking-eyebrow)', textTransform: 'uppercase', color: 'var(--color-text-muted)' } }, s[1]),
            h('span', { style: { fontSize: 'var(--text-sm)', lineHeight: 1.6, color: 'var(--color-text-muted)' } }, s[2])))))));

  var captions = h(Section, { tone: 'blush' },
    h('div', { 'data-opg-split': '', style: { display: 'grid', gridTemplateColumns: 'minmax(0,5fr) minmax(0,7fr)', gap: 'var(--space-7) var(--grid-gap-xl)', alignItems: 'center' } },
      h('div', { style: { minWidth: 0 } },
        h(SectionHead, { heading: 'A caption under every photo.', body: 'Add the names, a date or a few words for each photo, plus a title for the cover. For example:' }),
        h('ul', { style: { listStyle: 'none', margin: 'calc(var(--space-5) * -1) 0 0', padding: 0, display: 'flex', flexWrap: 'wrap', gap: 10 } },
          (A.captions || []).map((c, i) => h('li', { key: c, style: Object.assign({}, serif, { padding: '8px 16px 10px', background: 'var(--opg-white)', borderRadius: 2, fontSize: 'var(--text-xl)', color: 'var(--opg-navy-700)', transform: 'rotate(' + [-1.5, 1, -0.5, 1.5, -1][i % 5] + 'deg)', boxShadow: '0 8px 18px -14px rgba(20,28,60,.6)' }) }, c, ' \u2661'))),
        h('p', { style: { margin: 'var(--space-6) 0 0', fontSize: 'var(--text-sm)', lineHeight: 1.6, color: 'var(--opg-navy-900)' } }, 'Please double-check the spelling of every name, date and caption. We print exactly what you send.')),
      h('img', { loading: 'lazy', decoding: 'async', src: img('album-hardback-spreads'), alt: 'Hardback albums open at a wedding photo with its caption and colouring page', style: { width: '100%', aspectRatio: '4 / 3', objectFit: 'cover', borderRadius: 'var(--radius-md)' } })));

  var steps = h(Section, { tone: 'white' },
    h(SectionHead, { heading: 'From camera roll to album.', align: 'center' }),
    h('ol', { 'data-opg-cols': '', style: { listStyle: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(170px,1fr))', gap: 'var(--space-6) var(--grid-gap-lg)', textAlign: 'center' } },
      A.steps.map((s, i) => h('li', { key: s.title, style: { display: 'grid', justifyItems: 'center', alignContent: 'start', gap: 8 } },
        h('span', { style: Object.assign({}, serif, { width: 56, height: 56, borderRadius: '50%', border: '1.5px solid var(--color-accent-warm)', display: 'grid', placeItems: 'center', fontSize: 'var(--text-2xl)', lineHeight: 1, fontVariantNumeric: 'lining-nums', marginBottom: 8, color: 'var(--color-accent-warm)' }) }, i + 1),
        h('strong', { style: { fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--color-brand)' } }, s.title),
        h('span', { style: { fontSize: 'var(--text-sm)', lineHeight: 1.6, color: 'var(--color-text-muted)', maxWidth: '28ch' } }, s.body)))));

  var story = h(Section, { tone: 'paper' },
    h('div', { 'data-opg-split': '', style: { display: 'grid', gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)', gap: 'var(--space-7) var(--grid-gap-xl)', alignItems: 'center' } },
      h('img', { loading: 'lazy', decoding: 'async', src: img('album-photo-left'), alt: 'A colouring photo album open at a wedding photo beside its colouring page', style: { width: '100%', aspectRatio: '4 / 3', objectFit: 'cover', borderRadius: 'var(--radius-md)' } }),
      h('div', { style: { minWidth: 0 } },
        h(SectionHead, { heading: 'Any photo works. Mix them all in.', body: 'Phone snaps, slightly blurry shots and decades-old prints all come out really well. The real photo sits beside its colouring page, so the memory matters more than the file. Send them in the order you want them to appear.' }),
        h('ul', { style: { listStyle: 'none', margin: 'calc(var(--space-5) * -1) 0 0', padding: 0, display: 'flex', flexWrap: 'wrap', gap: 8 } },
          (A.memories || []).map(x => h('li', { key: x }, h(Tag, { tone: 'neutral' }, x)))))));

  var occasions = h(Section, { tone: 'white', pad: 'compact' },
    h('div', { style: { display: 'grid', justifyItems: 'center', textAlign: 'center', gap: 14 } },
      h(Eyebrow, null, 'A Gift That Becomes Part Of The Memory'),
      h('p', { style: Object.assign({}, serif, { margin: 0, maxWidth: '60ch', fontSize: 'var(--text-xl)', lineHeight: 1.6, color: 'var(--color-brand)' }) }, (A.occasions || []).join(' \xB7 '))));

  return h(React.Fragment, null,
    h(HeroFilm, { page: 'album' }),
    page1, spread, formats, captions, steps, story, occasions,
    h(Manifesto, { tone: 'navy', caps: false, heading: 'A creative activity today. A keepsake for years to come.', body: 'Children colour the pages; parents and grandparents keep the finished album. Part photo album, part colouring book, part family keepsake.' }),
    h(FaqAccordion, Object.assign({ heading: 'Questions before you order' }, A.faqs ? { items: A.faqs } : {})),
    h(StickyProductCTA, { title: A.title, price: '\xA3' + price, ctaLabel: 'Personalise Your Album', onCta: scrollTop }));
}
Object.assign(window, {
  PhotoAlbumPage
});
;
var {
  Eyebrow: OSEyebrow,
  Button: OSButton,
  BrushRule: OSBrushRule,
  BeforeAfterSlider: OSSlider,
  Manifesto: OSManifesto,
  FullBleedBanner: OSBanner
} = window.OnePrintGalleryDesignSystem_ba4735;
var osImg = {
  width: '100%',
  objectFit: 'cover',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--color-border)',
  background: 'var(--opg-white)',
  display: 'block'
};
var osP = {
  margin: 0,
  fontSize: 'var(--text-lg)',
  lineHeight: 1.75,
  color: 'var(--color-text)',
  textWrap: 'pretty'
};
var OS_CHAPTERS = [{
  n: '01',
  title: 'Colouring became our calm.',
  body: ['My son has autism and ADHD. Some days the world is loud for him, and finding something that helps him settle isn’t always easy.', 'Colouring turned out to be one of those things. We’d sit together at the dining table, pencils out, and I watched him slow down, focus and find his own quiet. It became our time.'],
  img: 'transform/colouring-after.webp',
  alt: 'Line-art page of a child colouring at the dining table'
}, {
  n: '02',
  title: 'Then we ran out of books worth colouring.',
  body: ['We went through every generic colouring book you could think of: animals, vehicles, cartoon characters, patterns. They did the job for a while, but none of them were really his.', 'I kept thinking: what if the pages were him? His family, his favourite places, his birthday party last year. Something he’d recognise and actually want to pick up.'],
  img: 'transform/family-after.webp',
  alt: 'Line-art page of a whole family, cat included'
}, {
  n: '03',
  title: 'Art, meet technology.',
  body: ['I’ve always had two passions: art and technology. For years they lived in separate parts of my life. Making a book for my son was the first time they came together properly.', 'I found a way to turn our own photographs into clean, detailed line art, with recognisable faces, real places, the little details that make a memory yours. The first book I made was for him. One Print Gallery grew from there.'],
  img: 'transform/football-after.webp',
  alt: 'Line-art page of Saturday morning football'
}];
var OS_VALUES = [{
  t: 'Made from your memories',
  b: 'Every page starts with your photographs. No stock templates with a name dropped in.'
}, {
  t: 'Made by a parent',
  b: 'I know what it means to find something that genuinely works for your child. Every order gets that same care.'
}, {
  t: 'Made for everyone',
  b: 'Children, grandparents, schools and care homes: anyone who deserves something that’s truly theirs.'
}];
function OurStoryPage(_ref) {
  var {
    go
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroFilm, {
    page: "story"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container-reading)',
      display: 'grid',
      gap: 'var(--space-6)',
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1.0,
      letterSpacing: 'var(--tracking-hero)',
      color: 'var(--color-brand)',
      maxWidth: '16ch',
      textWrap: 'balance'
    }
  }, "It started at the dining table, with my son and a box of pencils."), /*#__PURE__*/React.createElement("p", {
    style: {
      ...osP,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-text-muted)',
      maxWidth: '52ch'
    }
  }, "One Print Gallery isn\u2019t a factory or a template shop. It\u2019s a dad who found something that helped his son, and wanted to make it personal."), /*#__PURE__*/React.createElement(OSBrushRule, {
    width: 88
  }))), OS_CHAPTERS.map((c, i) => /*#__PURE__*/React.createElement(Section, {
    key: c.n,
    tone: i % 2 ? 'paper' : 'white',
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: i % 2 ? '5fr 6fr' : '6fr 5fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      order: i % 2 ? 2 : 1,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-accent-warm)',
      lineHeight: 1
    }
  }, c.n), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      maxWidth: '18ch',
      textWrap: 'balance'
    }
  }, c.title), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)',
      maxWidth: '54ch'
    }
  }, c.body.map(p => /*#__PURE__*/React.createElement("p", {
    key: p,
    style: osP
  }, p)))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      order: i % 2 ? 1 : 2
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + c.img,
    alt: c.alt,
    style: {
      ...osImg,
      aspectRatio: '4 / 5'
    }
  }))))), /*#__PURE__*/React.createElement(Section, {
    tone: "blush",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: '0 auto',
      maxWidth: 'var(--container-reading)',
      textAlign: 'center',
      display: 'grid',
      justifyItems: 'center',
      gap: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontStyle: 'italic',
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)',
      maxWidth: '24ch',
      textWrap: 'balance'
    }
  }, "\u201CThe first time he saw himself on the page, he didn\u2019t want to put the pencils down.\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, "Leon, Founder"))), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 6fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(OSSlider, {
    ratio: "4 / 5",
    beforeSrc: OPG_A("../../assets/web/transform/wedding-before-aligned.webp"),
    afterSrc: OPG_A("../../assets/web/transform/wedding-after-aligned.webp")
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "What We Make Now",
    heading: "The same care, for every family.",
    body: "What began as one book for my son now reaches families, grandparents, schools and care homes. Every order is still made the way that first one was: from real photographs, refined by hand until it feels like the memory."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '12px'
    }
  }, /*#__PURE__*/React.createElement(OSButton, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/personalised-colouring-books/')
  }, "Colouring Books"), /*#__PURE__*/React.createElement(OSButton, {
    variant: "secondary",
    size: "lg",
    onClick: () => go('/photo-album/')
  }, "Photo Albums"))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement("ul", {
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--space-6) var(--grid-gap-lg)'
    }
  }, OS_VALUES.map(v => /*#__PURE__*/React.createElement("li", {
    key: v.t,
    style: {
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border-strong)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-brand)'
    }
  }, v.t), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '10px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '40ch'
    }
  }, v.b)))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-8)',
      display: 'grid',
      justifyItems: 'start',
      gap: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/signature.webp"),
    alt: "Designed with love by One Print Gallery",
    style: {
      width: 'min(380px,100%)',
      height: 'auto',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-xl)',
      color: 'var(--color-accent-warm)'
    }
  }, "Leon, Founder"))), /*#__PURE__*/React.createElement(OSManifesto, null), /*#__PURE__*/React.createElement(OSBanner, {
    align: "center",
    heading: "Your next keepsake is already in your camera roll.",
    ctaLabel: "Create Your Book",
    ctaHref: "/create/",
    secondaryLabel: "See How It Works",
    secondaryHref: "/how-it-works/"
  }));
}
Object.assign(window, {
  OurStoryPage
});
;
var {
  Eyebrow: PEyebrow,
  Button: PButton,
  BeforeAfterSlider: PSlider,
  FormField: PField,
  Input: PInput,
  Select: PSelect,
  Textarea: PTextarea,
  Icon: PIcon,
  CASE_STUDIES: P_CASES
} = window.OnePrintGalleryDesignSystem_ba4735;
var pImg = {
  width: '100%',
  objectFit: 'cover',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--color-border)',
  background: 'var(--opg-white)',
  display: 'block'
};
var pCap = {
  marginTop: 10,
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-xs)',
  fontWeight: 700,
  letterSpacing: 'var(--tracking-eyebrow)',
  textTransform: 'uppercase',
  color: 'var(--color-text-muted)'
};
var pH3 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-2xl)',
  lineHeight: 1.1,
  color: 'var(--color-brand)'
};
var pBody = {
  margin: 0,
  fontSize: 'var(--text-base)',
  lineHeight: 1.7,
  color: 'var(--color-text-muted)',
  maxWidth: '52ch'
};
var P_SCHOOL = [{
  t: 'Class photo',
  b: 'b2b/school-class-before.webp',
  a: 'b2b/school-class-after.webp'
}, {
  t: 'Science lesson',
  b: 'b2b/school-science-before.webp',
  a: 'b2b/school-science-after.webp'
}, {
  t: 'School garden',
  b: 'b2b/school-garden-before.webp',
  a: 'b2b/school-garden-after.webp'
}];
var P_STEPS = [{
  t: 'A conversation',
  b: 'Tell us about your setting, who the books are for and roughly how many you need.'
}, {
  t: 'Your photos',
  b: 'Send the photographs you want included, with any permissions already in place. Any photo works.'
}, {
  t: 'A proof to approve',
  b: 'We transform every page and send a digital proof. Nothing is printed until you’re happy.'
}, {
  t: 'Printed and delivered',
  b: 'Books are printed to order and delivered to your door, ready to hand out.'
}];
var P_TYPES = ['School', 'SEN setting', 'Care home', 'Football club', 'Charity or organisation', 'Something else'];
var P_QTY = ['Under 25', '25–50', '50–150', '150+', 'Not sure yet'];
function PartnershipsPage(_ref) {
  var {
    go
  } = _ref;
  var [sent, setSent] = React.useState(() => window.OPG_POSTED === 'partnership');
  var [ex, setEx] = React.useState(0);
  var toForm = () => {
    var el = document.getElementById('enquire');
    if (el) window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - 20,
      behavior: 'smooth'
    });
  };
  var cs = (P_CASES || []).find(c => c.audience === 'schools');
  var pair = P_SCHOOL[ex];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeroFilm, {
    page: "partner"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 6fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-6)',
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1.0,
      letterSpacing: 'var(--tracking-hero)',
      color: 'var(--color-brand)',
      maxWidth: '15ch',
      textWrap: 'balance'
    }
  }, "Colouring books built around your people."), /*#__PURE__*/React.createElement("p", {
    style: {
      ...pBody,
      fontSize: 'var(--text-lg)'
    }
  }, "We make bespoke colouring books for schools, SEN settings, care homes, clubs and organisations, with every page drawn from your own photographs, so the people colouring them recognise what they see."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(PButton, {
    variant: "primary",
    size: "lg",
    onClick: toForm
  }, "Discuss a Project"), /*#__PURE__*/React.createElement(PButton, {
    variant: "secondary",
    size: "lg",
    onClick: () => go('/our-story/')
  }, "Our Story"))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(PSlider, {
    ratio: "3 / 2",
    beforeSrc: OPG_A("../../assets/web/b2b/school-class-before.webp"),
    afterSrc: OPG_A("../../assets/web/b2b/school-class-after.webp")
  })))), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Who We Work With"), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.08,
      color: 'var(--color-brand)'
    }
  }, "Find out how it works for you.")), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, [['Schools & SEN', 'Welcome and transition books, leavers’ keepsakes and calm, familiar resources for your pupils.', '/partnerships/schools-sen/', OPG_A('../../assets/web/b2b/school-garden-after.webp')], ['Care Homes', 'Personal books made from residents’ own photographs and life stories, for activities, visits and keepsakes.', '/partnerships/care-homes/', OPG_A('../../assets/web/b2b/care-nanny-after.webp')], ['Football Clubs', 'An official club colouring book for the club shop and matchday, with a low-risk trial to start.', '/partnerships/football-clubs/', OPG_A('../../assets/web/clubs/celebrate-before.webp')]].map(_ref2 => {
    var [t, b, h, img] = _ref2;
    return /*#__PURE__*/React.createElement("li", {
      key: h
    }, /*#__PURE__*/React.createElement("a", {
      href: h,
      style: {
        display: 'grid',
        gap: 14,
        textDecoration: 'none',
        color: 'inherit'
      }
    }, /*#__PURE__*/React.createElement("img", {
      loading: "lazy",
      decoding: "async",
      src: img,
      alt: "",
      style: {
        ...pImg,
        aspectRatio: '4 / 3'
      }
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: 'var(--font-display)',
        fontWeight: 600,
        fontSize: 'var(--text-xl)',
        color: 'var(--color-brand)'
      }
    }, t), /*#__PURE__*/React.createElement("span", {
      style: {
        ...pBody,
        fontSize: 'var(--text-sm)'
      }
    }, b), /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: 600,
        color: 'var(--color-accent)',
        textDecoration: 'underline'
      }
    }, "Learn more")));
  })))), cs ? /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-navy-700)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      maxWidth: 'var(--container)',
      marginInline: 'auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gridTemplateColumns: '7fr 5fr',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, {
    onDark: true,
    keep: true
  }, cs.client, " \xB7 ", cs.descriptor), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: '18px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 'var(--leading-heading)',
      color: 'var(--opg-white)',
      maxWidth: '18ch'
    }
  }, cs.headline), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '20px 0 0',
      fontSize: 'var(--text-base)',
      lineHeight: 1.7,
      color: 'var(--color-text-on-dark-muted)',
      maxWidth: '52ch'
    }
  }, cs.body)), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'flex',
      gap: 'var(--space-8)'
    }
  }, cs.metrics.map(m => /*#__PURE__*/React.createElement("div", {
    key: m.label
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1,
      color: 'var(--opg-peach-300)'
    }
  }, m.value), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-text-on-dark-muted)'
    }
  }, m.label)))), cs.quote ? /*#__PURE__*/React.createElement("figure", {
    style: {
      gridColumn: '1 / -1',
      margin: 'var(--space-6) 0 0',
      paddingTop: 'var(--space-7)',
      borderTop: '1px solid rgba(255,255,255,.18)',
      display: 'grid',
      gap: 18,
      maxWidth: '68ch'
    }
  }, /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-xl)',
      lineHeight: 1.45,
      color: 'var(--opg-white)',
      textWrap: 'pretty'
    }
  }, "\u201C", cs.quote, "\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--opg-peach-300)',
      fontWeight: 700
    }
  }, cs.quoteBy), " \xB7 ", cs.quoteRole)) : null)) : null, /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 7fr',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Schools & SEN"), /*#__PURE__*/React.createElement("h2", {
    style: {
      ...pH3,
      fontSize: 'var(--text-3xl)',
      maxWidth: '16ch'
    }
  }, "A school can become the content."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "Class photos, school trips, the garden, the science lab. Pupils colour pages of their own classmates, teachers and spaces: the places they know every day."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "Order a single book for the whole class, or a personalised copy for every pupil."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
      marginTop: 'var(--space-2)'
    }
  }, P_SCHOOL.map((p, i) => /*#__PURE__*/React.createElement("button", {
    key: p.t,
    type: "button",
    onClick: () => setEx(i),
    style: {
      padding: '9px 16px',
      borderRadius: 'var(--radius-round)',
      border: '1px solid ' + (i === ex ? 'var(--color-brand)' : 'var(--color-border)'),
      background: i === ex ? 'var(--color-brand)' : 'var(--opg-white)',
      color: i === ex ? 'var(--opg-white)' : 'var(--color-brand)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      cursor: 'pointer'
    }
  }, p.t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + pair.b,
    alt: pair.t + ', original photo',
    style: {
      ...pImg,
      aspectRatio: '3 / 2'
    }
  }), /*#__PURE__*/React.createElement("figcaption", {
    style: pCap
  }, "Original photo")), /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + pair.a,
    alt: pair.t + ', as a colouring page',
    style: {
      ...pImg,
      aspectRatio: '3 / 2'
    }
  }), /*#__PURE__*/React.createElement("figcaption", {
    style: pCap
  }, "Colouring page"))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '7fr 5fr',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: 12
    }
  }, [['Original photo', 'b2b/care-nanny-before.webp'], ['Colouring page', 'b2b/care-nanny-after.webp'], ['Finished book', 'b2b/care-nanny-cover.webp']].map(_ref3 => {
    var [l, s] = _ref3;
    return /*#__PURE__*/React.createElement("figure", {
      key: l,
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("img", {
      loading: "lazy",
      decoding: "async",
      src: OPG_A('../../assets/web/') + s,
      alt: l,
      style: {
        ...pImg,
        aspectRatio: '5 / 7'
      }
    }), /*#__PURE__*/React.createElement("figcaption", {
      style: pCap
    }, l));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Care Homes"), /*#__PURE__*/React.createElement("h2", {
    style: {
      ...pH3,
      fontSize: 'var(--text-3xl)',
      maxWidth: '16ch'
    }
  }, "Personal stories, made into something to share."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "A book of a resident\u2019s own life (their wedding day, their children, the places they loved) to colour with family, carers or friends. Old, faded and creased photos all work beautifully."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "A thoughtful gift from families, or an activity for residents built around the memories that matter to them.")))), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("ul", {
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))',
      gap: 'var(--space-7) var(--grid-gap-lg)'
    }
  }, [{
    e: 'Football Clubs',
    h: 'Club identity, made interactive.',
    b: 'Matchday memories, the ground, the squad and supporter culture. Fan products that supporters actually pick up. Club marks and player imagery must be licensed.',
    img: 'transform/football-after.webp'
  }, {
    e: 'Organisations',
    h: 'Your people, place or story.',
    b: 'Charities, community groups and businesses: custom colouring books for events, anniversaries, fundraising and team gifts.',
    img: 'transform/getting-ready-after.webp'
  }].map(c => /*#__PURE__*/React.createElement("li", {
    key: c.e,
    style: {
      display: 'grid',
      gridTemplateColumns: '2fr 3fr',
      gap: 'var(--space-5)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A('../../assets/web/') + c.img,
    alt: "",
    style: {
      ...pImg,
      aspectRatio: '4 / 5'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, c.e), /*#__PURE__*/React.createElement("h3", {
    style: pH3
  }, c.h), /*#__PURE__*/React.createElement("p", {
    style: {
      ...pBody,
      fontSize: 'var(--text-sm)'
    }
  }, c.b)))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "How Partnerships Work",
    heading: "Four steps. We handle the difficult one."
  }), /*#__PURE__*/React.createElement("ol", {
    "data-opg-cols": "",
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(210px,1fr))',
      gap: 'var(--space-6) var(--grid-gap-lg)'
    }
  }, P_STEPS.map((s, i) => /*#__PURE__*/React.createElement("li", {
    key: s.t,
    style: {
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border-strong)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-accent-warm)',
      lineHeight: 1
    }
  }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: '14px 0 0',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      color: 'var(--color-brand)'
    }
  }, s.t), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '8px 0 0',
      fontSize: 'var(--text-sm)',
      lineHeight: 1.65,
      color: 'var(--color-text-muted)',
      maxWidth: '34ch'
    }
  }, s.b))))), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    id: "enquire",
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: '5fr 7fr',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(PEyebrow, null, "Discuss a Project"), /*#__PURE__*/React.createElement("h2", {
    style: {
      ...pH3,
      fontSize: 'var(--text-3xl)',
      maxWidth: '14ch'
    }
  }, "Tell us what you have in mind."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "No commitment. We\u2019ll reply within two working days with ideas, timings and a quote.")), sent ? /*#__PURE__*/React.createElement("div", {
    role: "status",
    style: {
      minWidth: 0,
      padding: 'var(--space-7)',
      background: 'var(--opg-blush-100)',
      borderRadius: 'var(--radius-md)',
      display: 'grid',
      gap: 12,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      background: 'var(--color-brand)',
      color: 'var(--opg-white)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(PIcon, {
    name: "check",
    size: 20,
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("h3", {
    style: pH3
  }, "Thank you. We\u2019ve got it."), /*#__PURE__*/React.createElement("p", {
    style: pBody
  }, "We\u2019ll be in touch within two working days.")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      var f = e.currentTarget;
      var lines = Array.from(f.elements).filter(el => el.id && el.value).map(el => {
        var l = f.querySelector('label[for="' + el.id + '"]');
        return (l ? l.textContent.replace(/\s*(\*|Optional|Required)\s*$/i, '').trim() : el.id) + ': ' + el.value;
      });
      OPG_SEND('Partnership enquiry', lines, f, 'partnership');
    },
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(PField, {
    label: "Your name",
    htmlFor: "p-name",
    required: true
  }, /*#__PURE__*/React.createElement(PInput, {
    id: "p-name",
    required: true,
    autoComplete: "name"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Email",
    htmlFor: "p-email",
    required: true
  }, /*#__PURE__*/React.createElement(PInput, {
    id: "p-email",
    type: "email",
    required: true,
    autoComplete: "email"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Organisation",
    htmlFor: "p-org",
    required: true
  }, /*#__PURE__*/React.createElement(PInput, {
    id: "p-org",
    required: true,
    autoComplete: "organization"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Type of organisation",
    htmlFor: "p-type"
  }, /*#__PURE__*/React.createElement(PSelect, {
    id: "p-type",
    options: P_TYPES,
    placeholder: "Choose one"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Roughly how many books?",
    htmlFor: "p-qty",
    optional: true
  }, /*#__PURE__*/React.createElement(PSelect, {
    id: "p-qty",
    options: P_QTY,
    placeholder: "Choose one"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Ideal delivery date",
    htmlFor: "p-date",
    optional: true
  }, /*#__PURE__*/React.createElement(PInput, {
    id: "p-date",
    type: "date"
  })), /*#__PURE__*/React.createElement(PField, {
    label: "Tell us about your project",
    htmlFor: "p-msg",
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(PTextarea, {
    id: "p-msg",
    rows: 5
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(PButton, {
    variant: "primary",
    size: "lg",
    type: "submit"
  }, "Send Enquiry"))))));
}
Object.assign(window, {
  PartnershipsPage
});
;
var MDS = window.OnePrintGalleryDesignSystem_ba4735;
var {
  Eyebrow: MEyebrow,
  Button: MButton,
  BeforeAfterSlider: MSlider,
  FaqAccordion: MFaq,
  FullBleedBanner: MBanner,
  FormField: MField,
  Input: MInput,
  Select: MSelect,
  Textarea: MTextarea,
  Icon: MIcon,
  IconButton: MIconButton,
  EmptyState: MEmpty,
  TextLink: MLink
} = MDS;
var M_REVIEWS = MDS.REVIEWS || [],
  M_STATS = MDS.SHOP_STATS || {
    rating: 5,
    reviewCount: 50,
    sales: 201
  },
  M_FUL = MDS.FULFILMENT,
  M_PRICING = MDS.PRICING,
  M_ALBUM = MDS.PHOTO_ALBUM;
var mH1 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-4xl)',
  lineHeight: 1.02,
  letterSpacing: 'var(--tracking-display)',
  color: 'var(--color-brand)',
  textWrap: 'balance'
};
var mBody = {
  margin: 0,
  fontSize: 'var(--text-base)',
  lineHeight: 1.65,
  color: 'var(--color-text-muted)',
  maxWidth: '58ch'
};
var mImg = {
  width: '100%',
  objectFit: 'cover',
  borderRadius: 'var(--radius-md)',
  border: '1px solid var(--color-border)',
  background: 'var(--opg-white)',
  display: 'block'
};
var PageIntro = _ref => {
  var {
    eyebrow,
    heading,
    body,
    tone = 'paper',
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Section, {
    tone: tone,
    pad: "standard"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18,
      maxWidth: 820
    }
  }, eyebrow ? /*#__PURE__*/React.createElement(MEyebrow, null, eyebrow) : null, /*#__PURE__*/React.createElement("h1", {
    style: mH1
  }, heading), body ? /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, body) : null, children));
};
var Chips = _ref2 => {
  var {
    items,
    value,
    onChange,
    label
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    role: "group",
    "aria-label": label,
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8
    }
  }, items.map(it => {
    var on = it === value;
    return /*#__PURE__*/React.createElement("button", {
      key: it,
      type: "button",
      "aria-pressed": on,
      onClick: () => onChange(it),
      style: {
        minHeight: 40,
        padding: '0 16px',
        borderRadius: 'var(--radius-round)',
        border: `1px solid ${on ? 'var(--color-brand)' : 'var(--color-border-strong)'}`,
        background: on ? 'var(--color-brand)' : 'transparent',
        color: on ? 'var(--opg-white)' : 'var(--color-brand)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: 600,
        cursor: 'pointer'
      }
    }, it);
  }));
};

/* ——— Transformation gallery ——— */
var GALLERY = [{
  id: 'jade-family',
  title: 'Three generations on the sofa',
  tags: ['Family', 'Children'],
  before: 'jade-family-before-aligned',
  after: 'jade-family-after-aligned',
  dir: 'transform'
}, {
  id: 'jade-wedding',
  title: 'Their wedding day',
  tags: ['Weddings', 'Family'],
  before: 'jade-wedding-before',
  after: 'jade-wedding-after',
  dir: 'transform',
  landscape: true
}, {
  id: 'baby',
  title: 'First time sitting up',
  tags: ['Children', 'Family'],
  before: 'baby-before-aligned',
  after: 'baby-after-aligned',
  dir: 'transform'
}, {
  id: 'pets',
  title: 'Best friends, fast asleep',
  tags: ['Pets'],
  before: 'pets-before-aligned',
  after: 'pets-after-aligned',
  dir: 'transform'
}, {
  id: 'cake',
  title: 'Make a wish',
  tags: ['Moments', 'Family'],
  before: 'cake-before-aligned',
  after: 'cake-after-aligned',
  dir: 'transform'
}, {
  id: 'family',
  title: 'A family afternoon',
  tags: ['Family'],
  before: 'family-before-aligned',
  after: 'family-after-aligned',
  dir: 'transform'
}, {
  id: 'colouring',
  title: 'Colouring together',
  tags: ['Children', 'Family'],
  before: 'colouring-before-aligned',
  after: 'colouring-after-aligned',
  dir: 'transform'
}, {
  id: 'cat',
  title: 'Window seat',
  tags: ['Pets'],
  before: 'cat-before-aligned',
  after: 'cat-after-aligned',
  dir: 'transform'
}, {
  id: 'skyline',
  title: 'The view from up there',
  tags: ['Places'],
  before: 'skyline-before',
  after: 'skyline-after',
  dir: 'transform'
}, {
  id: 'concert',
  title: 'Front row',
  tags: ['Moments'],
  before: 'concert-before',
  after: 'concert-after',
  dir: 'transform'
}, {
  id: 'tickets',
  title: 'The night we went',
  tags: ['Moments'],
  before: 'tickets-before-aligned',
  after: 'tickets-after-aligned',
  dir: 'transform'
}, {
  id: 'football',
  title: 'Matchday',
  tags: ['Sport', 'Children'],
  before: 'football-before',
  after: 'football-after',
  dir: 'transform'
}, {
  id: 'gaming',
  title: 'Game on',
  tags: ['Moments', 'Children'],
  before: 'gaming-before-aligned',
  after: 'gaming-after-aligned',
  dir: 'transform'
}, {
  id: 'roast',
  title: 'Sunday roast',
  tags: ['Moments'],
  before: 'roast-before-aligned',
  after: 'roast-after-aligned',
  dir: 'transform'
}, {
  id: 'wedding',
  title: 'The wedding day',
  tags: ['Weddings'],
  before: 'wedding-before-aligned',
  after: 'wedding-after-aligned',
  dir: 'transform'
}, {
  id: 'getting-ready',
  title: 'Getting ready',
  tags: ['Weddings', 'Family'],
  before: 'getting-ready-before-aligned',
  after: 'getting-ready-after-aligned',
  dir: 'transform'
}, {
  id: 'sunrise-bench',
  title: 'Sunrise by the lake',
  tags: ['Places'],
  before: 'sunrise-bench-before-aligned',
  after: 'sunrise-bench-after-aligned',
  dir: 'transform'
}, {
  id: 'lake-path',
  title: 'A walk by the water',
  tags: ['Places'],
  before: 'lake-path-before-aligned',
  after: 'lake-path-after-aligned',
  dir: 'transform'
}, {
  id: 'forest',
  title: 'Into the woods',
  tags: ['Places'],
  before: 'forest-before',
  after: 'forest-after',
  dir: 'transform'
}, {
  id: 'rose',
  title: 'From the garden',
  tags: ['Nature'],
  before: 'rose-before-aligned',
  after: 'rose-after-aligned',
  dir: 'transform'
}, {
  id: 'butterfly',
  title: 'A visitor on the leaf',
  tags: ['Nature'],
  before: 'butterfly-before',
  after: 'butterfly-after',
  dir: 'transform'
}, {
  id: 'baby-cat',
  title: 'Little ones',
  tags: ['Pets', 'Children'],
  before: 'baby-cat-before-aligned',
  after: 'baby-cat-after-aligned',
  dir: 'transform'
}, {
  id: 'nanny',
  title: 'Nanny’s photographs',
  tags: ['Family'],
  before: 'care-nanny-before-aligned',
  after: 'care-nanny-after-aligned',
  dir: 'b2b'
}];
var COVERS = [{
  id: 'luna',
  name: 'Starry & magical',
  cat: 'Children',
  best: 'Children’s books, bedtime keepsakes',
  front: OPG_A('../../assets/web/books/luna-front.webp'),
  back: OPG_A('../../assets/web/books/luna-back.webp')
}, {
  id: 'jade',
  name: 'Black & gold',
  cat: 'Family',
  best: 'Weddings, anniversaries, family books',
  front: OPG_A('../../assets/web/books/jade-front.webp'),
  back: OPG_A('../../assets/web/books/jade-back.webp')
}, {
  id: 'amelia-princess',
  name: 'Pastel princess',
  cat: 'Children',
  best: 'Dress-up days, little dreamers',
  front: OPG_A('../../assets/web/covers/amelia-princess.webp'),
  back: OPG_A('../../assets/web/covers/amelia-princess-back.webp')
}, {
  id: 'luna-kawaii',
  name: 'Cute & kawaii',
  cat: 'Children',
  best: 'Favourite characters, toys and games',
  front: OPG_A('../../assets/web/covers/luna-kawaii.webp'),
  back: OPG_A('../../assets/web/covers/luna-kawaii-back.webp')
}, {
  id: 'ella-family',
  name: 'Soft & playful',
  cat: 'Family',
  best: 'Family books for younger children',
  front: OPG_A('../../assets/web/covers/ella-family.webp'),
  back: OPG_A('../../assets/web/covers/ella-family-back.webp')
}, {
  id: 'ava-sienna-kai',
  name: 'Midnight hearts',
  cat: 'Children',
  best: 'Siblings, cousins, back to school',
  front: OPG_A('../../assets/web/covers/ava-sienna-kai.webp'),
  back: OPG_A('../../assets/web/covers/ava-sienna-kai-back.webp')
}, {
  id: 'sienna-16th',
  name: 'Pink party',
  cat: 'Birthdays',
  best: 'Sweet sixteens and big birthdays',
  front: OPG_A('../../assets/web/covers/sienna-16th.webp')
}, {
  id: 'chloe-party',
  name: 'Celebration',
  cat: 'Birthdays',
  best: 'Birthdays, new cars, family milestones',
  front: OPG_A('../../assets/web/covers/chloe-party.webp'),
  back: OPG_A('../../assets/web/covers/chloe-party-back.webp')
}, {
  id: 'sophia-glam',
  name: 'Leopard & glam',
  cat: 'Birthdays',
  best: 'Girls’ nights, hen parties, best friends',
  front: OPG_A('../../assets/web/covers/sophia-glam.webp')
}, {
  id: 'anniversary-hubby',
  name: 'Golden anniversary',
  cat: 'Couples',
  best: 'Anniversaries, with their hobbies woven in',
  front: OPG_A('../../assets/web/covers/anniversary-hubby.webp'),
  back: OPG_A('../../assets/web/covers/anniversary-hubby-back.webp')
}, {
  id: 'oliver-james',
  name: 'Spring romance',
  cat: 'Couples',
  best: 'Valentine’s Day, couples',
  front: OPG_A('../../assets/web/covers/oliver-james.webp'),
  back: OPG_A('../../assets/web/covers/oliver-james-back.webp')
}, {
  id: 'mason-daisy',
  name: 'Country & western',
  cat: 'Couples',
  best: 'Couples, holidays, date nights',
  front: OPG_A('../../assets/web/covers/mason-daisy.webp'),
  back: OPG_A('../../assets/web/covers/mason-daisy-back.webp')
}, {
  id: 'sophia-graduation',
  name: 'Graduation blue',
  cat: 'Occasions',
  best: 'Graduations and proud moments',
  front: OPG_A('../../assets/web/covers/sophia-graduation.webp'),
  back: OPG_A('../../assets/web/covers/sophia-graduation-back.webp')
}, {
  id: 'bella-fathers-day',
  name: 'Father’s Day',
  cat: 'Occasions',
  best: 'Father’s Day, Mother’s Day, grandparents',
  front: OPG_A('../../assets/web/covers/bella-fathers-day.webp')
}, {
  id: 'amelia-travel',
  name: 'Travel scrapbook',
  cat: 'Occasions',
  best: 'Gap years, holidays, adventures',
  front: OPG_A('../../assets/web/covers/amelia-travel.webp')
}];
function CoverCard(_ref3) {
  var {
    c
  } = _ref3;
  var [back, setBack] = React.useState(false);
  return /*#__PURE__*/React.createElement("li", {
    style: {
      display: 'grid',
      gap: 14,
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      aspectRatio: '1 / 1.414',
      borderRadius: '3px 8px 8px 3px',
      overflow: 'hidden',
      boxShadow: '0 22px 40px -22px rgba(20,28,60,.55)',
      background: 'var(--opg-white)'
    }
  }, c.fit === 'contain' ? /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: c.front,
    alt: "",
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      inset: '-10%',
      width: '120%',
      height: '120%',
      objectFit: 'cover',
      filter: 'blur(18px) saturate(1.1)',
      opacity: .9
    }
  }) : null, /*#__PURE__*/React.createElement("img", {
    src: back ? c.back : c.front,
    alt: `${c.name} cover, ${back ? 'back' : 'front'}`,
    loading: "lazy",
    style: {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: c.fit === 'contain' ? 'contain' : 'cover',
      objectPosition: 'center top',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: 18,
      background: 'linear-gradient(90deg, rgba(0,0,0,.25), rgba(0,0,0,0))',
      pointerEvents: 'none'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 6
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)'
    }
  }, c.name), c.back ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setBack(!back),
    style: {
      flex: 'none',
      padding: 0,
      border: 0,
      background: 'none',
      font: 'inherit',
      fontSize: 'var(--text-xs)',
      fontWeight: 600,
      color: 'var(--color-accent)',
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  }, back ? 'See front' : 'See back') : null), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-accent-warm)'
    }
  }, "Great for"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-sm)',
      lineHeight: 1.55,
      color: 'var(--color-text)'
    }
  }, c.best)));
}
function GalleryPage(_ref4) {
  var {
    go
  } = _ref4;
  var [f, setF] = React.useState('All');
  var [cf, setCf] = React.useState('All');
  var covers = COVERS.filter(c => cf === 'All' || c.cat === cf);
  var [open, setOpen] = React.useState(GALLERY[0].id);
  var list = GALLERY.filter(g => f === 'All' || g.tags.includes(f));
  var cur = GALLERY.find(g => g.id === open) || GALLERY[0];
  var src = (g, k) => OPG_A(`../../assets/web/${g.dir}/${g[k]}.webp`);
  var thumb = (g, k) => OPG_A(`../../assets/web/thumbs/${g.dir}/${g[k]}.webp`);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, {
    heading: "Real photos. Real pages.",
    body: "Every page here started as a customer\u2019s everyday photograph. Compare the originals with the finished colouring pages, then browse cover styles for inspiration."
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Gallery sections",
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
      marginTop: 8
    }
  }, [['Transformations', 'g-transform'], ['Cover styles', 'g-covers']].map(_ref5 => {
    var [l, id] = _ref5;
    return /*#__PURE__*/React.createElement("a", {
      key: id,
      href: `#${id}`,
      onClick: e => {
        e.preventDefault();
        var el = document.getElementById(id);
        if (el) window.scrollTo({
          top: el.getBoundingClientRect().top + window.scrollY - 90,
          behavior: 'smooth'
        });
      },
      style: {
        minHeight: 40,
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0 16px',
        borderRadius: 'var(--radius-round)',
        border: '1px solid var(--color-border-strong)',
        color: 'var(--color-brand)',
        textDecoration: 'none',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: 600
      }
    }, l);
  }))), /*#__PURE__*/React.createElement("div", {
    id: "g-transform"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "compact"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, cur.landscape ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1.33fr) minmax(0,1fr)',
      gap: 12,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: src(cur, 'before'),
    alt: "Original photo",
    style: {
      ...mImg,
      aspectRatio: '1402 / 1122'
    }
  }), /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: src(cur, 'after'),
    alt: "Finished colouring page",
    style: {
      ...mImg,
      aspectRatio: '1055 / 1491'
    }
  })) : /*#__PURE__*/React.createElement(MSlider, {
    key: cur.id,
    beforeSrc: src(cur, 'before'),
    afterSrc: src(cur, 'after'),
    ratio: "4 / 5"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(MEyebrow, { keep: true }, cur.tags.join(' · ')), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      color: 'var(--color-brand)'
    }
  }, cur.title), /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, "Faces, clothing and the small details that make it theirs, kept recognisable, then simplified into lines a child can colour."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 8
    }
  }, /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/create/')
  }, "Create Your Book"))))), /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      color: 'var(--color-brand)'
    }
  }, "More transformations"), /*#__PURE__*/React.createElement(Chips, {
    label: "Filter gallery",
    items: ['All', 'Family', 'Children', 'Weddings', 'Pets', 'Moments', 'Places', 'Nature', 'Sport'],
    value: f,
    onChange: setF
  })), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, list.map(g => /*#__PURE__*/React.createElement("li", {
    key: g.id
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => {
      setOpen(g.id);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    "aria-label": `Compare ${g.title}`,
    style: {
      display: 'grid',
      gap: 12,
      width: '100%',
      padding: 0,
      border: 0,
      background: 'none',
      textAlign: 'left',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 4,
      borderRadius: 'var(--radius-md)',
      overflow: 'hidden',
      outline: g.id === open ? '2px solid var(--color-brand)' : 'none',
      outlineOffset: 3
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: thumb(g, 'before'),
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '3 / 4',
      objectFit: 'cover',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: thumb(g, 'after'),
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '3 / 4',
      objectFit: 'cover',
      display: 'block',
      background: 'var(--opg-white)'
    }
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-brand)'
    }
  }, g.title)))))), /*#__PURE__*/React.createElement("div", {
    id: "g-covers"
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "blush"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Cover Styles",
    heading: "Find a cover that feels like them.",
    body: "Every cover is designed by hand around your photos, their name and the things they love. Pick a style you like when you order, or tell us their interests and favourite colours and we\u2019ll create something to suit."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(Chips, {
    label: "Filter cover styles",
    items: ['All', 'Children', 'Birthdays', 'Couples', 'Family', 'Occasions'],
    value: cf,
    onChange: setCf
  })), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))',
      gap: 'var(--space-8) var(--grid-gap-lg)',
      alignItems: 'start'
    }
  }, covers.map(c => /*#__PURE__*/React.createElement(CoverCard, {
    key: c.id,
    c: c
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-8)',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    size: "lg",
    onClick: () => go('/create/')
  }, "Create Your Book"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "You can describe your cover style in step 2."))), /*#__PURE__*/React.createElement(MBanner, {
    align: "center",
    heading: "Your next keepsake is already in your camera roll.",
    ctaLabel: "Create Your Book",
    ctaHref: "/create/"
  }));
}

/* ——— Reviews ——— */
var REVIEW_TOPICS = {
  'Colouring Books': r => /colouring book/i.test(r.product || ''),
  Quality: r => /quality|incredible|better than|beautiful/i.test(r.quote),
  'Customer Service': r => /leon|communicat|messag|delivered|above and beyond/i.test(r.quote),
  'Gift Reactions': r => /gift|loved|grand|daughter|son/i.test(r.quote)
};
function ReviewsPage(_ref6) {
  var {
    go
  } = _ref6;
  var [f, setF] = React.useState('All');
  var list = M_REVIEWS.filter(r => f === 'All' || REVIEW_TOPICS[f](r));
  var lead = M_REVIEWS[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "standard"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'end'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("h1", {
    style: mH1
  }, "In their words."), /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, "Verified reviews from customers who have already turned their photos into books. Read in full on our Etsy shop.")), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(3,minmax(0,1fr))',
      gap: 'var(--space-5)'
    }
  }, [[M_STATS.rating.toFixed(1), 'Average rating'], [M_STATS.reviewCount, 'Verified reviews'], [M_STATS.sales, 'Books and prints sold']].map(_ref7 => {
    var [v, l] = _ref7;
    return /*#__PURE__*/React.createElement("div", {
      key: l,
      style: {
        paddingTop: 14,
        borderTop: '1px solid var(--color-border-strong)'
      }
    }, /*#__PURE__*/React.createElement("dd", {
      style: {
        margin: 0,
        fontFamily: 'var(--font-display)',
        fontWeight: 600,
        fontSize: 'var(--text-3xl)',
        lineHeight: 1,
        color: 'var(--color-brand)'
      }
    }, v), /*#__PURE__*/React.createElement("dt", {
      style: {
        marginTop: 8,
        fontSize: 'var(--text-xs)',
        color: 'var(--color-text-muted)'
      }
    }, l));
  })))), lead ? /*#__PURE__*/React.createElement(Section, {
    tone: "navy",
    pad: "standard"
  }, /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      maxWidth: 900,
      display: 'grid',
      gap: 22
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 4,
      color: 'var(--opg-peach-300)'
    }
  }, [0, 1, 2, 3, 4].map(i => /*#__PURE__*/React.createElement(MIcon, {
    key: i,
    name: "star",
    size: 20,
    style: {
      fill: 'currentColor'
    }
  }))), /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 500,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.18,
      color: 'var(--opg-white)',
      textWrap: 'pretty'
    }
  }, "\u201C", lead.quote, "\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-on-dark-muted)'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--opg-white)'
    }
  }, lead.attribution), " \xB7 ", lead.source))) : null, /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement(Chips, {
    label: "Filter reviews",
    items: ['All', ...Object.keys(REVIEW_TOPICS)],
    value: f,
    onChange: setF
  })), list.length ? /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      columns: '300px 3',
      columnGap: 'var(--grid-gap-lg)'
    }
  }, list.map((r, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    style: {
      breakInside: 'avoid',
      marginBottom: 'var(--grid-gap-lg)',
      padding: 'var(--space-6)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      background: 'var(--opg-white)',
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 3,
      color: 'var(--color-accent-warm)'
    }
  }, [0, 1, 2, 3, 4].map(k => /*#__PURE__*/React.createElement(MIcon, {
    key: k,
    name: "star",
    size: 15,
    style: {
      fill: 'currentColor'
    }
  }))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 500,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.3,
      color: 'var(--color-brand)'
    }
  }, "\u201C", r.quote, "\u201D"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--color-text)'
    }
  }, r.attribution), " \xB7 ", r.product, /*#__PURE__*/React.createElement("br", null), r.source)))) : /*#__PURE__*/React.createElement(MEmpty, {
    icon: "star",
    heading: "No reviews in this group yet.",
    body: "Try another filter, or be the first."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(MLink, {
    href: "https://www.etsy.com/shop/OnePrintGallery#reviews",
    withArrow: true
  }, "Read all ", M_STATS.reviewCount, " reviews on Etsy"))), /*#__PURE__*/React.createElement(window.OPG_Slot, { name: "reviews" }), /*#__PURE__*/React.createElement(MBanner, {
    align: "center",
    heading: "Ready to make one of your own?",
    ctaLabel: "Create Your Book",
    ctaHref: "/create/"
  }));
}

/* ——— Journal ——— */
var JOURNAL = [{
  cat: 'Photo Tips',
  title: 'Any photo works: choosing pictures for a colouring book',
  dek: 'Why blurry phone snaps and faded prints make some of the best pages, and the few we’d skip.',
  img: OPG_A('../../assets/web/mockups/luna-before-after.webp')
}, {
  cat: 'Behind the Gallery',
  title: 'How a photograph becomes a colouring page',
  dek: 'From your upload to the finished line art: what we keep, what we simplify, and why a person checks every page.',
  img: OPG_A('../../assets/web/transform/family-after.webp')
}, {
  cat: 'Gift Ideas',
  title: 'A gift for grandparents that gets coloured together',
  dek: 'Family photos, one book, two generations with the pencils out.',
  img: OPG_A('../../assets/web/mockups/luna-held.webp')
}, {
  cat: 'Customer Stories',
  title: 'The Willows: 50 books, then 150 more',
  dek: 'How a specialist SEN school in Hayes built a colouring book around its own people and places.',
  img: OPG_A('../../assets/web/b2b/school-class-after.webp')
}, {
  cat: 'One-of-One Art',
  title: 'The Highland Cows trio',
  dek: 'See no evil, hear no evil, speak no evil: the story behind the series.',
  img: OPG_A('../../assets/web/art/highland-trio.webp')
}, {
  cat: 'Partnerships',
  title: 'Familiar photos in care homes',
  dek: 'Why recognisable faces and places turn a colouring session into a conversation.',
  img: OPG_A('../../assets/web/b2b/care-nanny-cover.webp')
}];
function JournalPage() {
  var [f, setF] = React.useState('All');
  var list = JOURNAL.filter(a => f === 'All' || a.cat === f);
  var [lead, ...rest] = list;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, {
    eyebrow: "Journal",
    heading: "Notes from the gallery.",
    body: "Photo tips, gift ideas and the stories behind the pages."
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white",
    pad: "compact"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(Chips, {
    label: "Journal categories",
    items: ['All', ...Array.from(new Set(JOURNAL.map(a => a.cat)))],
    value: f,
    onChange: setF
  })), lead ? /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => e.preventDefault(),
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)',
      gap: 'var(--space-6) var(--grid-gap-xl)',
      alignItems: 'center',
      textDecoration: 'none',
      marginBottom: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: lead.img,
    alt: "",
    style: {
      ...mImg,
      aspectRatio: '16 / 10'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(MEyebrow, { keep: true }, lead.cat), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.08,
      color: 'var(--color-brand)'
    }
  }, lead.title), /*#__PURE__*/React.createElement("span", {
    style: mBody
  }, lead.dek), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-accent)',
      display: 'inline-flex',
      gap: 6,
      alignItems: 'center'
    }
  }, "Read the article ", /*#__PURE__*/React.createElement(MIcon, {
    name: "arrow-right",
    size: 16
  })))) : null, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))',
      gap: 'var(--space-7) var(--grid-gap-lg)'
    }
  }, rest.map(a => /*#__PURE__*/React.createElement("li", {
    key: a.title
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => e.preventDefault(),
    style: {
      display: 'grid',
      gap: 12,
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: a.img,
    alt: "",
    style: {
      ...mImg,
      aspectRatio: '4 / 3'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: '0.6875rem',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-accent-warm)'
    }
  }, a.cat), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)'
    }
  }, a.title), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, a.dek)))))));
}

/* ——— FAQ ——— */
var FAQ_GROUPS = () => [{
  id: 'ordering',
  title: 'Ordering',
  items: [{
    q: 'What sizes and page counts can I choose?',
    a: `A4 (our standard size) or A5, with 10, 15, 20 or 25 pages. Books start from ${M_PRICING.from}; the photo album starts from ${M_ALBUM.from}.`
  }, {
    q: 'Can I order more than one copy?',
    a: 'Yes. Choose the quantity when you create your book. Extra copies are printed from the same photographs.'
  }, {
    q: 'Do you make books for schools, care homes or clubs?',
    a: 'We do. Visit Partnerships to tell us about your project and we will reply with ideas, timings and a quote.'
  }]
}, {
  id: 'photos',
  title: 'Your photos',
  items: [{
    q: 'What photos work best?',
    a: 'Your favourites. Phone snaps, slightly blurred shots, old prints and decades-old pictures all come out really well, so please do not stress about finding the best-quality version.'
  }, {
    q: 'How do I send my photos?',
    a: 'Upload them while you create your book, in the order you want them to appear. You need one photo per page (so 10 for a 10-page book) before you can check out, which means nothing is held up waiting for photos later.'
  }, {
    q: 'What happens to my photos afterwards?',
    a: 'They are used only to create your order and handled in line with our Privacy Policy.'
  }]
}, {
  id: 'preview',
  title: 'Preview & production',
  items: [{
    q: 'Can I see my book before it is printed?',
    a: 'Yes. Choose “request a preview” while personalising. We email your pages for approval and start production once you reply.'
  }, {
    q: 'How long does it take?',
    a: `${M_FUL.production}. Requesting a preview may add time while you approve.`
  }]
}, {
  id: 'delivery',
  title: 'Delivery',
  items: [{
    q: 'How long does delivery take?',
    a: `${M_FUL.shipping}. ${M_FUL.shippingNote}`
  }, {
    q: 'Where do you ship from?',
    a: `${M_FUL.shipsFrom}. We ship internationally.`
  }]
}, {
  id: 'returns',
  title: 'Returns',
  items: [{
    q: 'Can I return my book?',
    a: `${M_FUL.returns} If anything is wrong with your order, get in touch and we will put it right.`
  }]
}];
function FaqPage(_ref8) {
  var {
    go
  } = _ref8;
  var groups = FAQ_GROUPS();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, {
    heading: "Questions, answered.",
    body: "Everything you might want to know before you order. Can\u2019t see yours? We\u2019re a message away."
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "FAQ topics",
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
      marginTop: 8
    }
  }, groups.map(g => /*#__PURE__*/React.createElement("a", {
    key: g.id,
    href: `#faq-${g.id}`,
    onClick: e => {
      e.preventDefault();
      var el = document.getElementById('faq-' + g.id);
      if (el) window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 90,
        behavior: 'smooth'
      });
    },
    style: {
      minHeight: 40,
      display: 'inline-flex',
      alignItems: 'center',
      padding: '0 16px',
      borderRadius: 'var(--radius-round)',
      border: '1px solid var(--color-border-strong)',
      color: 'var(--color-brand)',
      textDecoration: 'none',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-sm)',
      fontWeight: 600
    }
  }, g.title)))), groups.map((g, i) => /*#__PURE__*/React.createElement("div", {
    key: g.id,
    id: `faq-${g.id}`
  }, /*#__PURE__*/React.createElement(MFaq, {
    tone: i % 2 ? 'paper' : 'white',
    eyebrow: g.title,
    heading: g.title === 'Ordering' ? 'Ordering your book' : g.title,
    items: g.items
  }))), /*#__PURE__*/React.createElement(Section, {
    tone: "blush",
    pad: "compact"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 20,
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      color: 'var(--color-brand)'
    }
  }, "Still wondering about something?"), /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    onClick: () => go('/contact/')
  }, "Contact Us"))));
}

/* ——— Contact ——— */
function ContactPage(_ref9) {
  var {
    go
  } = _ref9;
  var [sent, setSent] = React.useState(() => window.OPG_POSTED === 'contact');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageIntro, {
    heading: "Talk to a real person.",
    body: "Questions about an order, a photo you\u2019re unsure of, or a gift with a deadline? Send us a note and Leon or the team will reply."
  }), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,4fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, sent ? /*#__PURE__*/React.createElement("div", {
    role: "status",
    style: {
      padding: 'var(--space-7)',
      background: 'var(--opg-blush-100)',
      borderRadius: 'var(--radius-md)',
      display: 'grid',
      gap: 12,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      background: 'var(--color-brand)',
      color: 'var(--opg-white)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(MIcon, {
    name: "check",
    size: 20
  })), /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-2xl)',
      color: 'var(--color-brand)'
    }
  }, "Thank you. Your message is with us."), /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, "We\u2019ve sent a copy to your inbox. If it\u2019s about an existing order, we\u2019ll look it up before we reply.")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      var f = e.currentTarget;
      var lines = Array.from(f.elements).filter(el => el.id && el.value).map(el => {
        var l = f.querySelector('label[for="' + el.id + '"]');
        return (l ? l.textContent.replace(/\s*(\*|Optional|Required)\s*$/i, '').trim() : el.id) + ': ' + el.value;
      });
      OPG_SEND('Website enquiry', lines, f, 'contact');
    },
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(MField, {
    label: "Your name",
    htmlFor: "ct-name",
    required: true
  }, /*#__PURE__*/React.createElement(MInput, {
    id: "ct-name",
    required: true,
    autoComplete: "name"
  })), /*#__PURE__*/React.createElement(MField, {
    label: "Email",
    htmlFor: "ct-email",
    required: true
  }, /*#__PURE__*/React.createElement(MInput, {
    id: "ct-email",
    type: "email",
    required: true,
    autoComplete: "email"
  })), /*#__PURE__*/React.createElement(MField, {
    label: "What is it about?",
    htmlFor: "ct-topic"
  }, /*#__PURE__*/React.createElement(MSelect, {
    id: "ct-topic",
    options: ['An existing order', 'A question before ordering', 'Photos and preview', 'One-of-One art', 'Something else'],
    placeholder: "Choose one"
  })), /*#__PURE__*/React.createElement(MField, {
    label: "Order number",
    htmlFor: "ct-order",
    optional: true
  }, /*#__PURE__*/React.createElement(MInput, {
    id: "ct-order",
    placeholder: "OPG-"
  })), /*#__PURE__*/React.createElement(MField, {
    label: "Your message",
    htmlFor: "ct-msg",
    required: true,
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(MTextarea, {
    id: "ct-msg",
    rows: 6,
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    size: "lg",
    type: "submit"
  }, "Send Message"))), /*#__PURE__*/React.createElement("aside", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, [['mail', 'General & orders', 'enquiries@oneprintgallery.co.uk', 'mailto:enquiries@oneprintgallery.co.uk'], ['instagram', 'Instagram', '@1oneprintgallery', 'https://instagram.com/1oneprintgallery']].map(_ref0 => {
    var [ic, l, v, h] = _ref0;
    return /*#__PURE__*/React.createElement("div", {
      key: l,
      style: {
        display: 'grid',
        gridTemplateColumns: '24px minmax(0,1fr)',
        gap: 14,
        paddingBottom: 'var(--space-5)',
        borderBottom: '1px solid var(--color-border)'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'var(--color-accent-warm)',
        paddingTop: 2
      }
    }, /*#__PURE__*/React.createElement(MIcon, {
      name: ic,
      size: 20
    })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        fontSize: 'var(--text-xs)',
        color: 'var(--color-text-muted)'
      }
    }, l), /*#__PURE__*/React.createElement("a", {
      href: h,
      style: {
        display: 'block',
        marginTop: 4,
        fontFamily: 'var(--font-sans)',
        fontWeight: 600,
        color: 'var(--color-brand)',
        overflowWrap: 'anywhere'
      }
    }, v)));
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, "Planning something for a school, care home or club? ", /*#__PURE__*/React.createElement("a", {
    href: "/partnerships/",
    style: {
      color: 'var(--color-brand)',
      fontWeight: 600
    }
  }, "Discuss a project"), ".")))));
}

/* ——— Cart ——— */
function CartPage(_ref1) {
  var {
    go
  } = _ref1;
  var [lines, setLines] = React.useState([{
    id: 1,
    title: 'Personalised Photo Colouring Book',
    img: OPG_A('../../assets/web/books/luna-front.webp'),
    options: ['The Adventures of Luna', 'A4 · 21 × 29.7 cm', '15 pages · 15 photos uploaded', 'Preview requested'],
    price: 24.99,
    qty: 1
  }]);
  var setQty = (id, d) => setLines(ls => ls.map(l => l.id === id ? {
    ...l,
    qty: Math.max(1, l.qty + d)
  } : l));
  var sub = lines.reduce((s, l) => s + l.price * l.qty, 0);
  if (!lines.length) return /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement(MEmpty, {
    icon: "shopping-bag",
    heading: "Your bag is empty.",
    body: "Your next keepsake is already in your camera roll.",
    actionLabel: "Create Your Book",
    onAction: () => go('/create/')
  }));
  return /*#__PURE__*/React.createElement(Section, {
    tone: "paper"
  }, /*#__PURE__*/React.createElement("h1", {
    style: {
      ...mH1,
      fontSize: 'var(--text-3xl)',
      marginBottom: 'var(--space-7)'
    }
  }, "Your bag"), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,4fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, lines.map(l => /*#__PURE__*/React.createElement("li", {
    key: l.id,
    style: {
      display: 'grid',
      gridTemplateColumns: '110px minmax(0,1fr)',
      gap: 'var(--space-5)',
      padding: 'var(--space-5)',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: l.img,
    alt: "",
    style: {
      width: '100%',
      aspectRatio: '1122 / 1402',
      objectFit: 'cover',
      borderRadius: 3
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10,
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.2,
      color: 'var(--color-brand)'
    }
  }, l.title), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, "\xA3", (l.price * l.qty).toFixed(2))), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 3
    }
  }, l.options.map(o => /*#__PURE__*/React.createElement("li", {
    key: o,
    style: {
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, o))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 4
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      border: '1px solid var(--color-border-strong)',
      borderRadius: 'var(--radius-sm)'
    }
  }, /*#__PURE__*/React.createElement(MIconButton, {
    label: "One fewer",
    onClick: () => setQty(l.id, -1)
  }, /*#__PURE__*/React.createElement(MIcon, {
    name: "minus",
    size: 15
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 32,
      textAlign: 'center',
      fontWeight: 700
    }
  }, l.qty), /*#__PURE__*/React.createElement(MIconButton, {
    label: "One more",
    onClick: () => setQty(l.id, 1)
  }, /*#__PURE__*/React.createElement(MIcon, {
    name: "plus",
    size: 15
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(MLink, {
    href: "/create/"
  }, "Edit personalisation"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setLines(ls => ls.filter(x => x.id !== l.id)),
    style: {
      padding: 0,
      border: 0,
      background: 'none',
      font: 'inherit',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)',
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  }, "Remove"))))))), /*#__PURE__*/React.createElement("aside", {
    "data-opg-sticky": "",
    style: {
      position: 'sticky',
      top: 'calc(var(--header-height) + 24px)',
      padding: 'var(--space-6)',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Subtotal"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-text)',
      fontWeight: 600
    }
  }, "\xA3", sub.toFixed(2))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Shipping"), /*#__PURE__*/React.createElement("span", null, "Calculated at checkout")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      paddingTop: 14,
      borderTop: '1px solid var(--color-border)',
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-lg)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("span", null, "\xA3", sub.toFixed(2))), /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    size: "lg",
    fullWidth: true,
    onClick: () => {
      window.__opgOrder = null;
      go('/order-confirmed/');
    }
  }, "Continue to Secure Checkout"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, M_FUL.production, ". ", M_FUL.returns))));
}

/* ——— 404 ——— */
function NotFoundPage(_ref10) {
  var {
    go
  } = _ref10;
  return /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "editorial"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(MEyebrow, null, "Page not found"), /*#__PURE__*/React.createElement("h1", {
    style: mH1
  }, "This page hasn\u2019t been drawn yet."), /*#__PURE__*/React.createElement("p", {
    style: mBody
  }, "The link may be old, or the page may have moved. Let\u2019s get you back to something worth colouring."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement(MButton, {
    variant: "primary",
    onClick: () => go('/')
  }, "Back to Home"), /*#__PURE__*/React.createElement(MButton, {
    variant: "secondary",
    onClick: () => go('/create/')
  }, "Create Your Book"))), /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: OPG_A("../../assets/web/transform/colouring-after.webp"),
    alt: "",
    style: {
      ...mImg,
      aspectRatio: '4 / 5'
    }
  })));
}
Object.assign(window, {
  GalleryPage,
  ReviewsPage,
  JournalPage,
  FaqPage,
  ContactPage,
  CartPage,
  NotFoundPage
});
;
var IDS = window.OnePrintGalleryDesignSystem_ba4735;
var {
  Eyebrow: IEyebrow,
  Button: IButton,
  ArtworkCard: IArtwork
} = IDS;
var I_FUL = IDS.FULFILMENT,
  I_ALBUM = IDS.PHOTO_ALBUM,
  I_ART = IDS.ART_PRINTS;
var I_EMAIL = 'enquiries@oneprintgallery.co.uk';
var I_UPDATED = 'October 2026';
var iH1 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-4xl)',
  lineHeight: 1.02,
  letterSpacing: 'var(--tracking-display)',
  color: 'var(--color-brand)',
  textWrap: 'balance'
};
var iH2 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-2xl)',
  lineHeight: 1.15,
  color: 'var(--color-brand)'
};
var iP = {
  margin: 0,
  fontSize: 'var(--text-base)',
  lineHeight: 1.7,
  color: 'var(--color-text)',
  maxWidth: '66ch',
  textWrap: 'pretty'
};
var iLink = {
  color: 'var(--color-brand)',
  fontWeight: 600
};
function InfoIntro(_ref) {
  var {
    eyebrow,
    heading,
    body
  } = _ref;
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-paper)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement(IEyebrow, null, eyebrow), /*#__PURE__*/React.createElement("h1", {
    style: iH1
  }, heading), body ? /*#__PURE__*/React.createElement("p", {
    style: {
      ...iP,
      color: 'var(--color-text-muted)',
      maxWidth: '58ch'
    }
  }, body) : null));
}

/* Long-form reading page: a list of { h, p: [..] | node } blocks. */
function InfoDoc(_ref2) {
  var {
    eyebrow,
    heading,
    body,
    blocks
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoIntro, {
    eyebrow: eyebrow,
    heading: heading,
    body: body
  }), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container-reading)',
      margin: '0 auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, blocks.map(b => /*#__PURE__*/React.createElement("div", {
    key: b.h,
    style: {
      display: 'grid',
      gap: 12,
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: iH2
  }, b.h), (Array.isArray(b.p) ? b.p : [b.p]).map((t, i) => /*#__PURE__*/React.createElement("p", {
    key: i,
    style: iP
  }, t)))), /*#__PURE__*/React.createElement("p", {
    style: {
      ...iP,
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, "Last updated ", I_UPDATED, ". Questions? Email ", /*#__PURE__*/React.createElement("a", {
    href: 'mailto:' + I_EMAIL,
    style: iLink
  }, I_EMAIL), "."))));
}
function ShippingPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {"eyebrow":"Shipping","heading":"Made to order, posted with care.","body":"Every book is made from your photographs, so we make it when you order, then pack it and post it from the United Kingdom.","blocks":[{"h":"Making your order","p":["Colouring books and photo albums are made to order in 2–4 business days.","One-of-One art prints are printed to order.","If you ask for a preview, we email your pages for approval first. Production starts when you reply, so the times on this page count from your approval."]},{"h":"UK delivery","p":["Delivery is charged at checkout, where you can choose standard or express delivery.","Standard delivery typically takes 5–7 business days once your order is made. One-of-One art prints typically arrive in 4–14 days."]},{"h":"International delivery","p":["We post worldwide. Once your order is made, delivery typically takes 7–10 business days to Europe and 10–14 business days to the rest of the world.","Delivery charges are shown at checkout."]},{"h":"Customs, duties and taxes","p":"Orders sent outside the UK may be charged import duties, taxes or handling fees by the destination country. These are not included in our prices or delivery charges and are paid by the customer, usually to the courier on delivery."},{"h":"Tracking","p":"We email you when your order is posted, with tracking where the service includes it."},{"h":"If your parcel is late","p":"Delivery times are estimates. If your parcel hasn’t arrived when expected, email enquiries@oneprintgallery.co.uk with your order number and we’ll chase it with the courier."},{"h":"Something wrong with your order?","p":"If anything arrives damaged or isn’t right, email enquiries@oneprintgallery.co.uk within 14 days of delivery with your order number and a photo, and we’ll put it right. See our Refunds page for the details."}]});
}
function RefundsPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {"eyebrow":"Refunds","heading":"If something isn’t right, we’ll put it right.","body":"Every item is made just for you, so refunds work a little differently from an ordinary shop.","blocks":[{"h":"Cancelling an order","p":"You can cancel for a full refund until we start making your order. Email enquiries@oneprintgallery.co.uk as soon as you can with your order number. Once production has started we can’t cancel, because the item is personalised to you."},{"h":"Changing your mind","p":"Personalised items can’t be returned because you’ve changed your mind. The usual 14-day right to cancel doesn’t apply to items made to your own specification."},{"h":"Faulty, damaged or wrong items","p":"If your item arrives damaged, has a printing fault, or isn’t what you ordered, email enquiries@oneprintgallery.co.uk within 14 days of delivery with your order number and a photo. We’ll reprint it free of charge or refund you in full. You don’t need to send it back unless we ask."},{"h":"Names, captions and previews","p":"If you approved a preview, we print exactly what you approved, so please check spellings carefully. If the mistake is ours, we’ll reprint it free of charge."},{"h":"Lost parcels","p":"If your parcel goes missing, we’ll chase it with the courier. If it can’t be found, we’ll reprint it or refund you."},{"h":"Import duties","p":"Import duties and taxes on overseas orders are paid by the customer and can’t be refunded by us."},{"h":"How refunds are paid","p":"Refunds go back to your original payment method, usually within 5–10 business days of us approving them."},{"h":"Your legal rights","p":"Nothing in this policy affects your statutory rights under the Consumer Rights Act 2015."}]});
}
function PrivacyPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {"eyebrow":"Privacy","heading":"Your photos stay yours.","body":"We only use your photographs and details to make and deliver your order.","blocks":[{"h":"Who we are","p":"One Print Gallery is the trading name of Leon Thaxter, a sole trader in the United Kingdom, based at 31 Wilsmere Drive, Northolt, Middlesex UB5 4JA. Leon is responsible for the personal information described here. For anything about your data, email enquiries@oneprintgallery.co.uk."},{"h":"What we collect","p":["The details you give us when you order: your name, email, delivery address and phone number if you add one.","The photographs you upload, and any names, captions or messages for your book.","Basic information about how you use the website, only if you accept analytics cookies.","Payment is handled securely by our checkout provider. We never see or store your full card details."]},{"h":"How we use it","p":["To make, check and deliver your order, and to contact you about it.","To keep the sales records UK law requires.","To send marketing emails, only if you’ve said yes. Every email has an unsubscribe link."]},{"h":"Your photographs","p":["Your photos are seen only by the people making your order. We never sell them, share them or use them to train software.","We never show your photos or finished pages publicly, in our gallery or on social media, without your written permission.","We keep your uploaded photos for 90 days after your order is delivered, so we can reprint or reorder for you, then delete them. Ask us and we’ll delete them sooner."]},{"h":"How long we keep other information","p":"We keep order records for six years, as UK tax rules require. Marketing details are kept until you unsubscribe."},{"h":"Who we share it with","p":"Only the services we need to run the shop: Shopify, which runs our website and checkout, our payment providers, our printer and our delivery couriers. Each gets just enough to do their part. Some of these services store data outside the UK, using the safeguards UK law requires."},{"h":"Cookies","p":"We use essential cookies to keep your basket and checkout working. Analytics and marketing cookies are only used if you accept them in our cookie banner, and you can change your choice at any time."},{"h":"Your rights","p":"Under UK data protection law you can ask to see the information we hold about you, correct it, or ask us to delete it. Email enquiries@oneprintgallery.co.uk and we’ll reply within one month. You can also complain to the Information Commissioner’s Office (ico.org.uk)."}]});
}
function TermsPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {"eyebrow":"Terms","heading":"Terms of sale.","body":"The short version: tell us about any problem and we’ll put it right. The details are below.","blocks":[{"h":"Who we are","p":"This shop is run by Leon Thaxter, trading as One Print Gallery, a sole trader in the United Kingdom, based at 31 Wilsmere Drive, Northolt, Middlesex UB5 4JA. Email enquiries@oneprintgallery.co.uk."},{"h":"Your order","p":["When you place an order you’ll receive a confirmation email. Your order is accepted once we’ve checked your photos and started production.","Prices are in pounds sterling. We are not VAT registered, so no VAT is added. Delivery charges are shown at checkout."]},{"h":"Orders outside the UK","p":"We deliver worldwide. Any import duties, taxes or fees charged by your country are your responsibility and aren’t included in our prices."},{"h":"Your photographs","p":["By uploading photos you confirm you own them or have permission to use them, including permission from anyone who appears in them.","We won’t make pages from photos that are offensive or unlawful, or that use other people’s protected artwork, logos or characters. If a photo can’t be used, we’ll contact you before going any further."]},{"h":"Personalised items","p":["Because each item is made to your instructions, the usual 14-day right to cancel doesn’t apply once we start making it.","This doesn’t affect your legal rights if an item is faulty or not as described. See our Refunds page for the details."]},{"h":"Previews and changes","p":"If you request a preview, please check names, captions and pages carefully. Once you approve it, we print exactly what you’ve approved."},{"h":"Faulty or damaged items","p":"Email enquiries@oneprintgallery.co.uk within 14 days of delivery with your order number and a photo of the problem. We’ll reprint it or refund it."},{"h":"One-of-One art","p":"Artwork designs remain the property of One Print Gallery. Buying a print doesn’t give you the right to copy or resell the design."},{"h":"Law","p":"These terms are governed by the law of England and Wales. If you live elsewhere in the UK, you can also bring a claim in your local courts."}]});
}
function LegalNoticePage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {"eyebrow":"Legal notice","heading":"Who runs this shop.","body":"The details UK law asks every online shop to publish.","blocks":[{"h":"Business","p":["One Print Gallery is the trading name of Leon Thaxter, a sole trader in the United Kingdom.","Leon Thaxter is responsible for this website and everything sold on it."]},{"h":"Contact","p":["Address: 31 Wilsmere Drive, Northolt, Middlesex UB5 4JA","Email: enquiries@oneprintgallery.co.uk","We aim to reply within two business days."]},{"h":"VAT","p":"One Print Gallery is not registered for VAT."},{"h":"Website platform","p":"This shop runs on Shopify. Payments are processed securely by Shopify and its payment partners."},{"h":"Copyright","p":"All website text, photography, illustrations and One-of-One artwork are © One Print Gallery unless stated otherwise. Please don’t copy or reuse them without permission. Customer photographs remain the property of the customer."},{"h":"Complaints","p":"If something isn’t right, email enquiries@oneprintgallery.co.uk and we’ll do our best to put it right. If we can’t settle a complaint together, you can contact Citizens Advice (citizensadvice.org.uk) for free consumer advice."},{"h":"Governing law","p":"This website and all sales are governed by the law of England and Wales."}]});
}
function AccessibilityPage() {
  return /*#__PURE__*/React.createElement(InfoDoc, {
    eyebrow: "Accessibility",
    heading: "A shop everyone can use.",
    body: "We want everyone to be able to order a keepsake, whatever device or assistive technology they use.",
    blocks: [{
      h: 'Our aim',
      p: 'We design and test this website against the Web Content Accessibility Guidelines (WCAG) 2.2, level AA.'
    }, {
      h: 'What we’ve done',
      p: ['Text and buttons meet colour-contrast guidelines, and buttons are large enough to tap easily.', 'Every page works with a keyboard, with a visible focus outline.', 'Images have text descriptions, and forms have clear labels and error messages.', 'Animations stay still if your device is set to reduce motion.']
    }, {
      h: 'Where we’re still improving',
      p: 'The before-and-after slider can also be moved with the arrow keys. If any part of ordering is hard to use, we can take your order by email instead.'
    }, {
      h: 'Tell us',
      p: `If something doesn’t work for you, email ${I_EMAIL}. We’ll reply within two working days and help you place your order another way if needed.`
    }]
  });
}
var I_COLLECTIONS = {
  'highland-cows': {
    name: 'Highland Cows',
    eyebrow: 'One of One · Collection',
    heading: 'See, hear and speak no evil.',
    body: 'Three Highland calves, each covering eyes, ears or mouth. A gentle take on the Three Wise Monkeys, drawn in detailed pencil style. Beautiful alone, better as a set of three.'
  },
  'obsidian-society': {
    name: 'The Obsidian Society',
    eyebrow: 'One of One · Collection',
    heading: 'The Obsidian Society.',
    body: 'Five dark, cinematic portraits, numbered No. I to No. V. Designed to hang together as a series or stand alone as a statement piece.'
  }
};
var I_WORKS = [['See No Evil', 'Highland Cows', 'see-no-evil.webp'], ['Hear No Evil', 'Highland Cows', 'hear-no-evil.webp'], ['Speak No Evil', 'Highland Cows', 'speak-no-evil.webp'], ['The Boss', 'The Obsidian Society', 'obsidian-the-boss.webp', 'No. I'], ['Boardroom', 'The Obsidian Society', 'obsidian-boardroom.webp', 'No. II'], ['The Detective', 'The Obsidian Society', 'obsidian-the-detective.webp', 'No. III'], ['The Strategist', 'The Obsidian Society', 'obsidian-the-strategist.webp', 'No. IV'], ['The Assassin', 'The Obsidian Society', 'obsidian-the-assassin.webp', 'No. V']];
function CollectionPage(_ref3) {
  var {
    id,
    go
  } = _ref3;
  var c = I_COLLECTIONS[id];
  var works = I_WORKS.filter(w => w[1] === c.name);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoIntro, {
    eyebrow: c.eyebrow,
    heading: c.heading,
    body: c.body
  }), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      paddingInline: 'var(--gutter)',
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))',
      gap: 'var(--space-8) var(--grid-gap-lg)'
    }
  }, works.map(_ref4 => {
    var [title, collection, f, no] = _ref4;
    return /*#__PURE__*/React.createElement("li", {
      key: title
    }, /*#__PURE__*/React.createElement(IArtwork, {
      badge: "Art Print",
      status: "available",
      ratio: "2 / 3",
      price: I_ART.from,
      priceFrom: true,
      title: title,
      collection: collection,
      href: opgArtHref(title, collection),
      medium: (no ? no + ' · ' : '') + I_ART.sizeRange,
      imageSrc: OPG_A('../../assets/web/art/') + f,
      href: (window.OPG && OPG.real && OPG.real['/art-collection/']) || '/#/art-collection/'
    }));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10,
      paddingTop: 'var(--space-6)',
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      ...iP,
      color: 'var(--color-text-muted)'
    }
  }, I_ART.paper, ". ", I_ART.delivery, ". ", I_ART.note), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IButton, {
    variant: "secondary",
    onClick: () => go('/art-collection/')
  }, "See the full Art Collection"))))));
}
Object.assign(window, {
  ShippingPage,
  PrivacyPage,
  TermsPage,
  AccessibilityPage,
  CollectionPage
});
;
var SDS = window.OnePrintGalleryDesignSystem_ba4735;
var {
  Eyebrow: SEyebrow,
  Button: SButton,
  BeforeAfterSlider: SSlider,
  FormField: SField,
  Input: SInput,
  Select: SSelect,
  Textarea: STextarea
} = SDS;
var S_STATS = SDS.SHOP_STATS || {};
var S_EMAIL = 'enquiries@oneprintgallery.co.uk',
  S_PHONE = '07732 226747';
var sH1 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-4xl)',
  lineHeight: 1.02,
  letterSpacing: 'var(--tracking-display)',
  color: 'var(--color-brand)',
  textWrap: 'balance'
};
var sH2 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-3xl)',
  lineHeight: 1.08,
  color: 'var(--color-brand)',
  textWrap: 'balance'
};
var sH3 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-xl)',
  lineHeight: 1.2,
  color: 'var(--color-brand)'
};
var sP = {
  margin: 0,
  fontSize: 'var(--text-base)',
  lineHeight: 1.7,
  color: 'var(--color-text-muted)',
  maxWidth: '62ch',
  textWrap: 'pretty'
};
var sWrap = {
  maxWidth: 'var(--container)',
  margin: '0 auto',
  paddingInline: 'var(--gutter)'
};
var sEy = {
  margin: 0,
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-xs)',
  fontWeight: 700,
  letterSpacing: 'var(--tracking-eyebrow)',
  textTransform: 'uppercase',
  color: 'var(--color-accent-warm)'
};
var A = OPG_A('../../assets/web/');
var SECTORS = {
  'schools-sen': {
    eyebrow: 'Partnerships · Schools & SEN',
    heading: 'Familiar faces. Familiar places.',
    body: 'Personalised colouring books and pages made from your school’s own photographs. A calm, creative resource for transition, wellbeing and celebration.',
    pair: {
      before: 'b2b/school-class-before.webp',
      after: 'b2b/school-class-after.webp'
    },
    inUse: {
      src: 'b2b/school-desk.webp',
      ratio: '4 / 5',
      eyebrow: 'In the classroom',
      heading: 'A calm activity with a story they recognise.',
      body: 'Pupils colour their own school, classmates and moments. A quiet, focused activity that also becomes a keepsake to take home.'
    },
    why: [['Personal and recognisable', 'Built around your people, spaces and moments rather than generic stock scenes.'], ['Calm creative time', 'A screen-free, self-paced activity that fits naturally into quiet or independent time.'], ['School–home connection', 'A keepsake gives families a natural prompt to talk about school memories and milestones.'], ['Flexible format', 'Complete books or individual pages, depending on what your school needs.']],
    optionsHeading: 'A pupil-featured edition or a school-only edition.',
    options: [['Pupil-featured', 'Class photos, classroom activities, trips, leavers and celebrations. We supply parent consent forms for the school to issue before any photographs are shared.'], ['School-only', 'Your building, classrooms, playgrounds and any staff happy to feature: a recognisable resource without including pupils.']],
    feature: {
      eyebrow: 'SEND & transition',
      heading: 'Familiar visuals can make change feel more understandable.',
      body: ['For some pupils, especially autistic children and young people, a new classroom, teacher or school brings uncertainty. A personalised colouring book complements your existing transition resources by turning those same familiar spaces into a calm activity a child can revisit at their own pace.', 'We worked with The Willows School Academy Trust, a specialist SEND school, on a bespoke colouring book built around their own school: 50 copies, followed by a reorder of 150.'],
      list: ['Starting school: the classroom, cloakroom, hall and the adults a child will meet', 'Moving class or key stage: made familiar before the change happens', 'Moving school: key spaces at the new school, revisited over the summer']
    },
    quote: {
      text: 'It has been a massive hit with staff, parents, and students alike. Seeing our school’s unique landmarks and ethos turned into beautiful illustrations was wonderful.',
      by: 'Malcolm Shaw · Headteacher, The Willows'
    },
    adapt: ['A4 or A5 page size', 'Larger colourable areas', 'Fine or bolder outlines', 'Names and captions optional', 'Simplified backgrounds', 'Single-sided pages'],
    uses: ['Welcome and transition books', 'Leavers’ keepsakes', 'Class or year-group books', 'Quiet-time activities', 'Fairs and fundraising', 'Personalised worksheets built around a pupil’s interests'],
    photos: 'Everyday phone photos are exactly what we work from. Slightly blurred shots, awkward angles and busy backgrounds are fine. Around 20–30 images is plenty for a 20-page book. Not sure about a photo? Send it and we’ll tell you honestly.',
    orgLabel: 'School or trust',
    msgHint: 'e.g. A welcome book for our new Reception class, featuring the classroom and staff.',
    trust: ['Parent consent forms supplied for pupil-featured editions', 'The school decides exactly which photographs are shared', 'A digital proof before anything is printed', 'Original artwork only, no trademarked characters or logos']
  },
  'care-homes': {
    eyebrow: 'Partnerships · Care Homes',
    heading: 'Meaningful activities, made personal.',
    body: 'Colouring books made from a resident’s own photographs, family moments, favourite places and life story. A creative activity and a keepsake that belongs to them.',
    pair: {
      before: 'b2b/care-nanny-before-aligned.webp',
      after: 'b2b/care-nanny-after-aligned.webp'
    },
    inUse: {
      src: 'b2b/care-table.webp',
      ratio: '4 / 5',
      eyebrow: 'In the activity room',
      heading: 'Something to share around the table.',
      body: 'Familiar faces and places give residents, staff and visiting family something to talk about while they colour together.'
    },
    why: [['Connection', 'Familiar images can encourage conversation and shared memories with staff, relatives and other residents.'], ['Choice', 'Each book can reflect the resident’s interests, culture, career, family, pets, music and important places.'], ['Keepsake', 'Enjoyed in activity sessions, revisited over time, and kept by the resident or their family.'], ['Shared time', 'Something to do together on a family visit, rather than sitting opposite one another.']],
    optionsHeading: 'Designed around the person, not the template.',
    options: [['Single resident book', '10–25 personalised pages with premium covers. Ideal for birthdays, welcome gifts and family keepsakes.'], ['Small pilot', 'A first project for 3–5 residents, so your activity team can try the idea before expanding.'], ['Shared home edition', 'Your garden, lounge, staff, activities and celebrations: one home-specific book, printed in a batch.'], ['Seasonal or community edition', 'Christmas, anniversaries, local history or fundraising, with families or local sponsors.']],
    feature: {
      eyebrow: 'Older photographs work just as well',
      heading: 'Faded, creased or slightly blurred is fine.',
      body: ['The photographs that mean most to a resident are often decades old: a print from an album, a frame on a windowsill, or a phone snap of one. Because every page is redrawn by hand rather than run through a filter, soft or damaged detail is interpreted and firmed up instead of lost.', 'These books are a creative engagement tool that complements your home’s own activity and wellbeing programme. They are not a medical treatment or therapy.'],
      list: ['Prints, albums, slides and newspaper cuttings', 'Phone photos of framed pictures', 'No professional scanning needed']
    },
    adapt: ['A4 or A5', 'Lay-flat coil binding', 'Large text', 'Bold or fine outlines', 'Simplified backgrounds', 'Larger colour areas', 'One-sided pages', 'Names and captions'],
    quote: {
      text: 'The elderly recipient can’t believe what an amazing book it is. She is in a care home and 94 years old in a few weeks, and colouring is her daily activity, so this has elevated the task exponentially.',
      by: 'Verified Etsy buyer'
    },
    orgLabel: 'Care home or organisation',
    msgHint: 'e.g. A small pilot for three residents, using photos from their families.',
    trust: ['Photographs supplied by the home or family, with permission in place', 'A digital proof before anything is printed', 'Only approved content appears in the finished book', 'A data processing agreement and process summary available on request']
  },
  'football-clubs': {
    eyebrow: 'Partnerships · Football Clubs',
    heading: 'The official club colouring book.',
    body: 'A family-friendly matchday keepsake built around your crest, your ground and your fans. Hand-produced in the UK, with a low-risk trial to test demand first.',
    pair: {
      before: 'clubs/celebrate-after.webp',
      after: 'clubs/celebrate-before.webp',
      ratio: '4 / 3'
    },
    inside: [['clubs/inside-kit.webp', 'Kit design'], ['clubs/inside-wordsearch.webp', 'Club wordsearch'], ['clubs/inside-spot.webp', 'Spot the difference']],
    inUse: {
      src: 'clubs/club-shop.webp',
      ratio: '4 / 3',
      eyebrow: 'On the shelf',
      heading: 'Made to sit alongside your merchandise.',
      body: 'Printed with premium covers in your club colours, so it looks at home in the club shop, on a matchday stall or in a gift bundle.'
    },
    covers: ['clubs/riverdale-cover-1.webp', 'clubs/riverdale-cover-2.webp', 'clubs/riverdale-cover-3.webp'],
    pairs: [['clubs/match-before.webp', 'clubs/match-after.webp', 'Sunday league action'], ['clubs/stadium-before.webp', 'clubs/stadium-after.webp', 'The view from the stand']],
    why: [['Fills a gap in the club shop', 'Most club shops are all kits and training wear. A book gives young fans something to do and keep.'], ['Something for every fan', 'An affordable add-on next to kits and training wear, so more families leave the shop with something.'], ['Ready for big moments', 'Promotion pushes, cup runs and anniversaries make natural special editions fans want to keep.'], ['Players drawn as line art', 'From first team to academy, players see themselves drawn, usually only done for top-flight professionals.']],
    optionsHeading: 'What’s inside.',
    options: [['Club pages', 'Your crest, your ground, home and away kits, supporter and fan-culture pages.'], ['Matchday activities', 'Player-inspired action scenes, a commemorative page, wordsearches and “design your own kit”.'], ['Four formats', 'A4 or A5, paperback or coil bound, every edition 15–20 pages with premium front and back covers.']],
    feature: {
      eyebrow: 'Where the partnership grows',
      heading: 'The colouring book is just the start.',
      body: ['The same design and print setup carries across the club, the Academy and the Foundation. All badge use, kit details, player likenesses, sponsor logos and “official” wording are approved by the club before printing, and anything involving children’s photographs follows your safeguarding policy in full.'],
      list: ['Commemorative editions for a promotion, cup run or anniversary', 'Foundation and schools: calming sheets and SEN-friendly activities', 'Academy Player of the Match and Player of the Season awards', 'A girls’ football activity edition', 'Summer-camp packs and sponsor-funded editions']
    },
    orgLabel: 'Club',
    msgHint: 'e.g. A trial batch of 25–50 books for the club shop this season.',
    trust: ['Club approval on every badge, kit and player likeness', 'Safeguarding and consent handled before any child’s photo is used', 'A sample cover and pages approved before printing', 'Designed and hand-produced in the UK']
  }
};
function SectorPage(_ref) {
  var {
    id,
    go
  } = _ref;
  var s = SECTORS[id];
  var [sent, setSent] = React.useState(() => window.OPG_POSTED === 'quote');
  var contact = () => {
    var el = document.getElementById('quote');
    if (el) window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - 80,
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-paper)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'minmax(0,6fr) minmax(0,5fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(SEyebrow, null, s.eyebrow), /*#__PURE__*/React.createElement("h1", {
    style: sH1
  }, s.heading), /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-lg)'
    }
  }, s.body), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      marginTop: 8
    }
  }, /*#__PURE__*/React.createElement(SButton, {
    variant: "primary",
    size: "lg",
    onClick: contact
  }, "Get a Quote"), /*#__PURE__*/React.createElement(SButton, {
    variant: "secondary",
    size: "lg",
    onClick: () => {
      window.location.href = 'mailto:' + S_EMAIL;
    }
  }, "Email Us"))), /*#__PURE__*/React.createElement(SSlider, {
    beforeSrc: A + s.pair.before,
    afterSrc: A + s.pair.after,
    ratio: s.pair.ratio || '4 / 5'
  }))), s.covers ? /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr)',
      gap: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "Your crest. Your ground. Your fans."), /*#__PURE__*/React.createElement("p", {
    style: sP
  }, "Sample editions for a fictional club, Riverdale FC. Yours would feature your own crest, kit and ground, approved by the club before printing.")), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, s.covers.map(c => /*#__PURE__*/React.createElement("li", {
    key: c
  }, /*#__PURE__*/React.createElement("img", {
    src: A + c,
    alt: "Sample club colouring book cover",
    loading: "lazy",
    style: {
      width: '100%',
      aspectRatio: '1 / 1.414',
      objectFit: 'cover',
      borderRadius: '3px 8px 8px 3px',
      boxShadow: '0 22px 40px -22px rgba(20,28,60,.55)',
      display: 'block'
    }
  })))), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,440px),1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, s.pairs.map(_ref2 => {
    var [b, a, t] = _ref2;
    return /*#__PURE__*/React.createElement("li", {
      key: t,
      style: {
        display: 'grid',
        gap: 10
      }
    }, /*#__PURE__*/React.createElement(SSlider, {
      beforeSrc: A + b,
      afterSrc: A + a,
      ratio: "4 / 3"
    }), /*#__PURE__*/React.createElement("p", {
      style: {
        ...sH3,
        fontSize: 'var(--text-lg)'
      }
    }, t));
  })), s.inside ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)',
      paddingTop: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "Colouring, puzzles and activities."), /*#__PURE__*/React.createElement("p", {
    style: sP
  }, "Alongside the colouring pages, each edition can include club-themed activity pages like these.")), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, s.inside.map(_ref3 => {
    var [src, t] = _ref3;
    return /*#__PURE__*/React.createElement("li", {
      key: t,
      style: {
        display: 'grid',
        gap: 10
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: A + src,
      alt: 'Sample activity page: ' + t,
      loading: "lazy",
      style: {
        width: '100%',
        aspectRatio: '1 / 1.414',
        objectFit: 'cover',
        borderRadius: 6,
        border: '1px solid rgba(0,0,0,.1)',
        display: 'block'
      }
    }), /*#__PURE__*/React.createElement("p", {
      style: {
        ...sH3,
        fontSize: 'var(--text-lg)'
      }
    }, t));
  }))) : null)) : null, s.inUse ? /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,340px),1fr))',
      gap: 'var(--space-8)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: A + s.inUse.src,
    alt: "",
    loading: "lazy",
    style: {
      width: '100%',
      aspectRatio: s.inUse.ratio,
      objectFit: 'cover',
      borderRadius: 12,
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12,
      alignContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, s.inUse.heading), /*#__PURE__*/React.createElement("p", {
    style: sP
  }, s.inUse.body)))) : null, /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "Why it works."), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 'var(--space-7) var(--grid-gap-lg)'
    }
  }, s.why.map((_ref4, i) => {
    var [t, b] = _ref4;
    return /*#__PURE__*/React.createElement("li", {
      key: t,
      style: {
        display: 'grid',
        gap: 10,
        alignContent: 'start',
        paddingTop: 16,
        borderTop: '1px solid var(--color-border-strong)'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: 700,
        color: 'var(--color-accent-warm)'
      }
    }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("h3", {
      style: sH3
    }, t), /*#__PURE__*/React.createElement("p", {
      style: {
        ...sP,
        fontSize: 'var(--text-sm)'
      }
    }, b));
  })))), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-blush-100)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gap: 'var(--space-8)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, s.optionsHeading), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--grid-gap-lg)'
    }
  }, s.options.map(_ref5 => {
    var [t, b] = _ref5;
    return /*#__PURE__*/React.createElement("li", {
      key: t,
      style: {
        display: 'grid',
        gap: 10,
        alignContent: 'start',
        padding: 'var(--space-6)',
        background: 'var(--opg-white)',
        borderRadius: 'var(--radius-md)',
        border: '1px solid var(--color-border)'
      }
    }, /*#__PURE__*/React.createElement("h3", {
      style: sH3
    }, t), /*#__PURE__*/React.createElement("p", {
      style: {
        ...sP,
        fontSize: 'var(--text-sm)'
      }
    }, b));
  })))), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, s.feature.heading), s.feature.body.map((t, i) => /*#__PURE__*/React.createElement("p", {
    key: i,
    style: sP
  }, t)), /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      paddingLeft: 20,
      display: 'grid',
      gap: 8
    }
  }, s.feature.list.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      fontSize: 'var(--text-base)',
      lineHeight: 1.6,
      color: 'var(--color-text)'
    }
  }, t)))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-6)'
    }
  }, s.adapt ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 14,
      padding: 'var(--space-6)',
      background: 'var(--opg-paper)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: sEy
  }, "Adaptable to every reader"), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8
    }
  }, s.adapt.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      padding: '7px 12px',
      borderRadius: 'var(--radius-round)',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text)'
    }
  }, t)))) : null, s.uses ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: sEy
  }, "Ways schools use them"), /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      paddingLeft: 20,
      display: 'grid',
      gap: 6
    }
  }, s.uses.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      fontSize: 'var(--text-sm)',
      lineHeight: 1.6,
      color: 'var(--color-text)'
    }
  }, t)))) : null, s.photos ? /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-sm)',
      paddingTop: 16,
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--color-brand)'
    }
  }, "Your photos don\u2019t need to be perfect. "), s.photos) : null, s.quote ? /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      display: 'grid',
      gap: 12,
      paddingTop: 16,
      borderTop: '1px solid var(--color-border)'
    }
  }, /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontStyle: 'italic',
      fontSize: 'var(--text-xl)',
      lineHeight: 1.35,
      color: 'var(--color-brand)'
    }
  }, "\u201C", s.quote.text, "\u201D"), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontSize: 'var(--text-xs)',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-text-muted)'
    }
  }, s.quote.by)) : null))), /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--opg-paper)',
      paddingBlock: 'var(--section-standard)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...sWrap,
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "Handled with care."), /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      paddingLeft: 20,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
      gap: '8px var(--grid-gap-lg)'
    }
  }, s.trust.map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      fontSize: 'var(--text-base)',
      lineHeight: 1.6,
      color: 'var(--color-text)'
    }
  }, t))), S_STATS.rating ? /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-sm)'
    }
  }, S_STATS.rating.toFixed(1), "\u2605 from ", S_STATS.reviewCount, " verified Etsy reviews \xB7 Every page drawn by hand in the UK.") : null)), /*#__PURE__*/React.createElement("section", {
    id: "quote",
    style: {
      background: 'var(--opg-white)',
      paddingBlock: 'var(--section-editorial)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      ...sWrap,
      display: 'grid',
      gridTemplateColumns: 'minmax(0,5fr) minmax(0,7fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 16,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(SEyebrow, null, "Get a Quote"), /*#__PURE__*/React.createElement("h2", {
    style: sH2
  }, "A quote built around your needs."), /*#__PURE__*/React.createElement("p", {
    style: sP
  }, "Every project is different, so we price each one on the page count, size, binding and quantity you need. Tell us a little about yours and Leon will reply personally with ideas, timings and a fixed quote before any artwork begins."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-base)',
      lineHeight: 1.8
    }
  }, "Prefer email or a call?", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: 'mailto:' + S_EMAIL,
    style: {
      color: 'var(--color-brand)',
      fontWeight: 600
    }
  }, S_EMAIL), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: 'tel:' + S_PHONE.replace(/\s/g, ''),
    style: {
      color: 'var(--color-brand)',
      fontWeight: 600
    }
  }, S_PHONE))), sent ? /*#__PURE__*/React.createElement("div", {
    role: "status",
    style: {
      display: 'grid',
      gap: 12,
      padding: 'var(--space-7)',
      background: 'var(--opg-paper)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      ...sH3,
      fontSize: 'var(--text-2xl)'
    }
  }, "Thank you. Your enquiry is with us."), /*#__PURE__*/React.createElement("p", {
    style: {
      ...sP,
      fontSize: 'var(--text-sm)'
    }
  }, "Leon will be in touch within two working days with some ideas and a quote.")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      var f = e.currentTarget;
      var lines = Array.from(f.elements).filter(el => el.id && el.value).map(el => {
        var l = f.querySelector('label[for="' + el.id + '"]');
        return (l ? l.textContent.replace(/\s*(\*|Optional|Required)\s*$/i, '').trim() : el.id) + ': ' + el.value;
      });
      OPG_SEND('Quote request — ' + s.eyebrow.replace('Partnerships · ', ''), lines, f, 'quote');
    },
    style: {
      minWidth: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(SField, {
    label: "Your name",
    htmlFor: "s-name",
    required: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-name",
    required: true,
    autoComplete: "name"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Email",
    htmlFor: "s-email",
    required: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-email",
    type: "email",
    required: true,
    autoComplete: "email"
  })), /*#__PURE__*/React.createElement(SField, {
    label: s.orgLabel,
    htmlFor: "s-org",
    required: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-org",
    required: true,
    autoComplete: "organization"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Phone",
    htmlFor: "s-phone",
    optional: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-phone",
    type: "tel",
    autoComplete: "tel"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Roughly how many books?",
    htmlFor: "s-qty",
    optional: true
  }, /*#__PURE__*/React.createElement(SSelect, {
    id: "s-qty",
    options: ['Just one or a few', 'Under 25', '25–50', '50–150', '150+', 'Not sure yet'],
    placeholder: "Choose one"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Ideal delivery date",
    htmlFor: "s-date",
    optional: true
  }, /*#__PURE__*/React.createElement(SInput, {
    id: "s-date",
    type: "date"
  })), /*#__PURE__*/React.createElement(SField, {
    label: "Tell us what you have in mind",
    htmlFor: "s-msg",
    required: true,
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(STextarea, {
    id: "s-msg",
    rows: 5,
    required: true,
    placeholder: s.msgHint
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      gridColumn: '1 / -1'
    }
  }, /*#__PURE__*/React.createElement(SButton, {
    variant: "primary",
    size: "lg",
    type: "submit"
  }, "Request a Quote"))))));
}
Object.assign(window, {
  SectorPage
});
;
var CDS = window.OnePrintGalleryDesignSystem_ba4735;
var {
  PersonalisationStepper: CStepper,
  PhotoUploader: CUploader,
  RadioCard: CRadioCard,
  Radio: CRadio,
  Checkbox: CCheckbox,
  FormField: CField,
  Input: CInput,
  Textarea: CTextarea,
  Button: CButton,
  Icon: CIcon,
  Eyebrow: CEyebrow,
  IconButton: CIconButton
} = CDS;
var C_PRICING = CDS.PRICING,
  C_FUL = CDS.FULFILMENT,
  C_ALBUM = CDS.PHOTO_ALBUM;
var cLabel = {
  margin: '0 0 10px',
  padding: 0,
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-sm)',
  fontWeight: 600,
  color: 'var(--color-brand)'
};
var cH2 = {
  margin: 0,
  fontFamily: 'var(--font-display)',
  fontWeight: 600,
  fontSize: 'var(--text-2xl)',
  lineHeight: 1.1,
  letterSpacing: 'var(--tracking-display)',
  color: 'var(--color-brand)'
};
var cBody = {
  margin: 0,
  fontSize: 'var(--text-sm)',
  lineHeight: 1.65,
  color: 'var(--color-text-muted)'
};
var cFieldset = {
  border: 'none',
  margin: 0,
  padding: 0,
  display: 'grid',
  gap: 10
};
var money = n => '£' + Number(n).toFixed(2);
function orderPrice(o) {
  var _C_PRICING$a4Extra;
  if (o.product === 'album') return Number(C_ALBUM.priceFor({
    pages: o.pages,
    binding: o.binding,
    size: o.size
  }));
  var p = C_PRICING.pages.find(x => x.count === o.pages) || C_PRICING.pages[0];
  return parseFloat(p.price.replace('£', '')) + (o.size === 'a4' ? (_C_PRICING$a4Extra = C_PRICING.a4Extra) !== null && _C_PRICING$a4Extra !== void 0 ? _C_PRICING$a4Extra : 3 : 0);
}
function orderLines(o) {
  var ok = o.photos.filter(p => p.state === 'uploaded').length;
  return [['Product', o.product === 'album' ? C_ALBUM.title : 'Personalised Photo Colouring Book'], ['Format', (o.size === 'a4' ? 'A4 · 21 × 29.7 cm' : 'A5 · 14.8 × 21 cm') + (o.product === 'album' ? ` · ${o.binding === 'hardback' ? 'Hardback' : 'Coil bound'}` : ' · Coil bound')], ['Pages', o.product === 'album' ? `${o.pages} photo pages + ${o.pages} colouring pages` : `${o.pages} colouring pages`], ['Photos', `${ok} of ${o.pages} uploaded`], ['Cover title', o.title || '—'], ['Cover photo', o.cover ? o.cover.name : 'We’ll choose the best one'], ['Cover colour', o.colour || 'Our choice'], ...(o.name ? [['Back cover', o.name]] : []), ['Preview', o.preview === 'yes' ? 'Preview requested before print' : 'No preview, straight to production'], ['Quantity', String(o.qty)]];
}
var C_SIZES = C_PRICING.formats;
var C_ALBUM_SIZES = [{
  id: 'a4',
  title: 'A4 · 21 × 29.7 cm',
  description: 'More room for larger photographs and detailed colouring pages.'
}, {
  id: 'a5',
  title: 'A5 · 14.8 × 21 cm',
  description: 'Compact and easy to handle.'
}];
var C_STEPS = ['Choose', 'Personalise', 'Upload', 'Preview', 'Review'];
function CreatePage(_ref) {
  var {
    go,
    product = 'book'
  } = _ref;
  var [step, setStep] = React.useState(0);
  var pk = opgPick(product);
  var pkOpts = (product === 'album' ? C_ALBUM.pages : C_PRICING.pages).map(p => p.count);
  var [o, setO] = React.useState({
    product,
    size: pk.size === 'a5' ? 'a5' : 'a4',
    pages: pkOpts.indexOf(pk.pages) > -1 ? pk.pages : (product === 'album' ? pkOpts[0] : 15),
    binding: pk.binding === 'hardback' ? 'hardback' : 'coil',
    qty: 1,
    title: '',
    name: '',
    colour: '',
    cover: null,
    message: '',
    photos: [],
    preview: '',
    rights: false
  });
  var set = (k, v) => setO(s => ({
    ...s,
    [k]: v
  }));
  var [tried, setTried] = React.useState(false);
  var unit = orderPrice(o),
    total = unit * o.qty;
  var ok = o.photos.filter(p => p.state === 'uploaded').length;
  var busy = o.photos.some(p => p.state === 'uploading');
  var album = o.product === 'album';
  var valid = [true, !!o.title.trim(), ok === o.pages && !busy, !!o.preview, o.rights][step];
  var top = () => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  var next = () => {
    if (!valid) {
      setTried(true);
      return;
    }
    setTried(false);
    if (step === 4) {
      window.__opgOrder = {
        ...o,
        unit,
        total
      };
      if (window.OPG_CHECKOUT) {
        window.OPG_CHECKOUT(window.__opgOrder);
        return;
      }
      go('/order-confirmed/');
      return;
    }
    setStep(step + 1);
    top();
  };
  var back = () => {
    setTried(false);
    setStep(Math.max(0, step - 1));
    top();
  };
  var pageOpts = (album ? C_ALBUM.pages : C_PRICING.pages).map(p => p.count);
  React.useEffect(() => { opgPick(o.product, { size: o.size, pages: o.pages, binding: o.binding }); }, [o.product, o.size, o.pages, o.binding]);
  return /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "compact"
  }, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Breadcrumb",
    style: {
      marginBottom: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    style: {
      color: 'inherit'
    }
  }, "Home"), " \xB7 ", /*#__PURE__*/React.createElement("a", {
    href: album ? '/photo-album/' : '/personalised-colouring-books/',
    style: {
      color: 'inherit'
    }
  }, album ? 'Colouring Photo Album' : 'Personalised Colouring Books'), album ? " \xB7 Create Your Album" : " \xB7 Create Your Book")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 'var(--space-5) var(--space-8)',
      alignItems: 'end',
      justifyContent: 'space-between',
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(CEyebrow, null, "Step ", step + 1, " of 5"), /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-3xl)',
      lineHeight: 1.05,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)'
    }
  }, "Create Your ", album ? 'Album' : 'Book')), /*#__PURE__*/React.createElement(CStepper, {
    steps: C_STEPS,
    current: step,
    onStep: i => {
      setStep(i);
      setTried(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,4fr)',
      gap: 'var(--space-7) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      padding: 'clamp(22px,3.5vw,44px)',
      display: 'grid',
      gap: 'var(--space-7)'
    }
  }, step === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, album ? "Choose your album" : "Choose your book"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "Prices update as you choose. You can change anything later, right up to checkout.")), /*#__PURE__*/React.createElement("fieldset", {
    style: cFieldset
  }, /*#__PURE__*/React.createElement("legend", {
    style: cLabel
  }, "Size"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 10
    }
  }, (album ? C_ALBUM_SIZES : C_SIZES).map(f => /*#__PURE__*/React.createElement(CRadioCard, {
    key: f.id,
    id: `c-size-${f.id}`,
    name: "c-size",
    title: f.title,
    description: f.description,
    checked: o.size === f.id,
    onChange: () => set('size', f.id)
  })))), album ? /*#__PURE__*/React.createElement("fieldset", {
    style: cFieldset
  }, /*#__PURE__*/React.createElement("legend", {
    style: cLabel
  }, "Binding"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 10
    }
  }, C_ALBUM.bindings.map(b => /*#__PURE__*/React.createElement(CRadioCard, {
    key: b.id,
    id: `c-bind-${b.id}`,
    name: "c-bind",
    title: b.title,
    description: b.description,
    meta: b.id === 'hardback' ? '+ £10.00' : null,
    checked: o.binding === b.id,
    onChange: () => set('binding', b.id)
  })))) : null, /*#__PURE__*/React.createElement("fieldset", {
    style: cFieldset
  }, /*#__PURE__*/React.createElement("legend", {
    style: cLabel
  }, album ? 'Number of spreads' : 'Number of pages'), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))',
      gap: 10
    }
  }, pageOpts.map(n => /*#__PURE__*/React.createElement(CRadioCard, {
    key: n,
    id: `c-pg-${n}`,
    name: "c-pages",
    title: `${n} ${album ? 'spreads' : 'pages'}`,
    description: `${money(orderPrice({
      ...o,
      pages: n
    }))} · ${n} photos`,
    checked: o.pages === n,
    onChange: () => set('pages', n)
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: cLabel
  }, "Quantity"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      border: '1px solid var(--color-border-strong)',
      borderRadius: 'var(--radius-sm)'
    }
  }, /*#__PURE__*/React.createElement(CIconButton, {
    label: "One fewer",
    onClick: () => set('qty', Math.max(1, o.qty - 1))
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "minus",
    size: 16
  })), /*#__PURE__*/React.createElement("span", {
    "aria-live": "polite",
    style: {
      minWidth: 40,
      textAlign: 'center',
      fontFamily: 'var(--font-sans)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, o.qty), /*#__PURE__*/React.createElement(CIconButton, {
    label: "One more",
    onClick: () => set('qty', Math.min(20, o.qty + 1))
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "plus",
    size: 16
  }))), /*#__PURE__*/React.createElement("p", {
    style: {
      ...cBody,
      marginTop: 10,
      fontSize: 'var(--text-xs)'
    }
  }, "Extra copies are printed from the same photos. Lovely for grandparents."))) : null, step === 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Your cover"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "Tell us what the cover should say. We design the cover artwork for you from your photos.")), /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,.8fr)',
      gap: 'var(--space-6)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement(CField, {
    label: "Cover title",
    htmlFor: "c-title",
    required: true,
    hint: "Up to 40 characters.",
    error: tried && !o.title.trim() ? 'Please add a title for the cover.' : undefined
  }, /*#__PURE__*/React.createElement(CInput, {
    id: "c-title",
    value: o.title,
    maxLength: 40,
    placeholder: "The Adventures of Luna",
    invalid: tried && !o.title.trim(),
    onChange: e => set('title', e.target.value)
  })), /*#__PURE__*/React.createElement(CField, {
    label: "Cover colour",
    htmlFor: "c-colour",
    optional: true,
    hint: "A colour, or a few, you\u2019d like the cover to use. Leave blank and we\u2019ll choose one to suit your photos."
  }, /*#__PURE__*/React.createElement(CInput, {
    id: "c-colour",
    value: o.colour,
    maxLength: 60,
    placeholder: "e.g. Pastel pink, or their favourite team\u2019s colours",
    onChange: e => set('colour', e.target.value)
  })), /*#__PURE__*/React.createElement(CField, {
    label: "Who is it for?",
    htmlFor: "c-name",
    optional: true,
    hint: "Used for a small dedication on the back cover."
  }, /*#__PURE__*/React.createElement(CInput, {
    id: "c-name",
    value: o.name,
    maxLength: 40,
    placeholder: "For Nanny, with love",
    onChange: e => set('name', e.target.value)
  })), /*#__PURE__*/React.createElement(CField, {
    label: "Cover preferences",
    htmlFor: "c-msg",
    optional: true,
    hint: "Any personal interests, or a personal message you\u2019d like to add to the back cover."
  }, /*#__PURE__*/React.createElement(CTextarea, {
    id: "c-msg",
    rows: 4,
    value: o.message,
    onChange: e => set('message', e.target.value)
  }))), /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    style: {
      aspectRatio: '1055 / 1491',
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: '2px 6px 6px 2px',
      boxShadow: '0 18px 36px -22px rgba(20,28,60,.45)',
      display: 'grid',
      gridTemplateRows: 'auto 1fr auto',
      padding: '12% 10%',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: 14,
      background: 'repeating-linear-gradient(180deg, var(--color-border-strong) 0 3px, transparent 3px 9px)'
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      textAlign: 'center',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'clamp(20px,2.4vw,30px)',
      lineHeight: 1.05,
      color: 'var(--color-brand)',
      textWrap: 'balance',
      overflowWrap: 'anywhere'
    }
  }, o.title || 'Your cover title'), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '10% 0',
      border: '1px dashed var(--color-border-strong)',
      borderRadius: 4,
      display: 'grid',
      placeItems: 'center',
      color: 'var(--color-text-muted)',
      fontSize: 'var(--text-xs)',
      textAlign: 'center',
      padding: 10
    }
  }, o.cover ? 'Cover artwork drawn from your chosen photo' : 'Cover artwork drawn from your photos'), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      textAlign: 'center',
      fontFamily: 'var(--font-sans)',
      fontSize: '0.6875rem',
      fontWeight: 700,
      letterSpacing: 'var(--tracking-eyebrow)',
      textTransform: 'uppercase',
      color: 'var(--color-accent-warm)'
    }
  }, "One Print Gallery")), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      ...cBody,
      fontSize: 'var(--text-xs)'
    }
  }, "Text preview only. Your finished cover is designed by hand."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 8,
      marginTop: 'var(--space-4)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      ...cLabel,
      margin: 0
    }
  }, "Front cover photo ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 400,
      color: 'var(--color-text-muted)'
    }
  }, "(optional)")), /*#__PURE__*/React.createElement("input", {
    id: "c-cover",
    type: "file",
    accept: "image/jpeg,image/png,image/heic,image/heif,.heic,.heif",
    hidden: true,
    onChange: e => {
      var f = e.target.files && e.target.files[0];
      if (f) set('cover', {
        name: f.name,
        src: /^image\/(jpe?g|png|webp|gif)/.test(f.type) ? URL.createObjectURL(f) : null
      });
      e.target.value = '';
    }
  }), o.cover ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '56px minmax(0,1fr) auto',
      gap: 12,
      alignItems: 'center',
      padding: '10px 12px',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-sm)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 56,
      height: 56,
      borderRadius: 'var(--radius-xs)',
      background: 'var(--opg-mist)',
      overflow: 'hidden',
      display: 'grid',
      placeItems: 'center',
      color: 'var(--color-text-muted)'
    }
  }, o.cover.src ? /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: o.cover.src,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }) : /*#__PURE__*/React.createElement(CIcon, {
    name: "image",
    size: 20
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 0,
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      color: 'var(--color-text)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, o.cover.name), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => document.getElementById('c-cover').click(),
    style: {
      padding: 0,
      border: 0,
      background: 'none',
      font: 'inherit',
      fontSize: 'var(--text-sm)',
      color: 'var(--color-brand)',
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  }, "Change"), /*#__PURE__*/React.createElement(CIconButton, {
    label: "Remove cover photo",
    size: 36,
    onClick: () => set('cover', null)
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "trash-2",
    size: 17
  })))) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => document.getElementById('c-cover').click(),
    style: {
      display: 'flex',
      gap: 12,
      alignItems: 'center',
      padding: '14px 16px',
      border: '1px dashed var(--color-brand)',
      borderRadius: 'var(--radius-sm)',
      background: 'var(--opg-paper)',
      color: 'var(--color-brand)',
      font: 'inherit',
      fontSize: 'var(--text-sm)',
      fontWeight: 600,
      cursor: 'pointer',
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "upload",
    size: 20,
    strokeWidth: 1.5
  }), "Upload a photo for the front cover"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, o.cover ? 'We’ll build the cover artwork around this photo.' : 'No need to choose. If you skip this, we’ll pick the photo we feel works best for the cover.'))))) : null, step === 2 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Upload ", o.pages, " photographs"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "One photo per ", album ? 'spread' : 'page', ", in the order you want them. Phone snaps, blurry shots and old prints all work beautifully. Choose the moments, not the sharpest file.", album ? ' Add the names or a short caption to print under each photo.' : '')), /*#__PURE__*/React.createElement(CUploader, {
    required: o.pages,
    photos: o.photos,
    captions: album,
    onChange: ps => set('photos', ps)
  }), o.photos.some(p => p.dup) ? /*#__PURE__*/React.createElement("p", {
    role: "alert",
    style: {
      ...cBody,
      padding: '12px 14px',
      borderRadius: 'var(--radius-sm)',
      border: '1px solid var(--color-error)',
      color: 'var(--color-error)',
      fontWeight: 600
    }
  }, "We spotted the same photo twice. Every page needs a different photo, so please remove the one marked in red and choose another. (Your cover photo can be one of your page photos.)") : null, !busy && ok !== o.pages ? /*#__PURE__*/React.createElement("p", {
    role: tried ? 'alert' : undefined,
    style: {
      ...cBody,
      padding: '12px 14px',
      borderRadius: 'var(--radius-sm)',
      background: tried ? 'transparent' : 'var(--opg-blush-100)',
      border: tried ? '1px solid var(--color-error)' : '1px solid transparent',
      color: tried ? 'var(--color-error)' : 'var(--color-text-muted)',
      fontWeight: tried ? 600 : 400
    }
  }, ok < o.pages ? `Your ${album ? 'album' : 'book'} has ${o.pages} pages, so we need all ${o.pages} photos before you can continue (${o.pages - ok} to go).` : `You have ${ok - o.pages} more photo${ok - o.pages > 1 ? 's' : ''} than pages. Remove ${ok - o.pages}, or go back and choose more pages.`) : null, tried && busy ? /*#__PURE__*/React.createElement("p", {
    role: "alert",
    style: {
      ...cBody,
      color: 'var(--color-error)',
      fontWeight: 600
    }
  }, "Hang on, a photo is still uploading.") : null) : null, step === 3 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Would you like a preview?"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "Every page is checked by hand before print either way. A preview simply lets you see the pages yourself first.")), /*#__PURE__*/React.createElement("fieldset", {
    style: {
      ...cFieldset,
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("legend", {
    style: {
      position: 'absolute',
      width: 1,
      height: 1,
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)'
    }
  }, "Preview preference"), /*#__PURE__*/React.createElement(CRadioCard, {
    id: "c-prev-no",
    name: "c-prev",
    title: "Create my book without a preview",
    description: `We go straight into production. ${C_FUL.production}.`,
    checked: o.preview === 'no',
    onChange: () => set('preview', 'no')
  }), /*#__PURE__*/React.createElement(CRadioCard, {
    id: "c-prev-yes",
    name: "c-prev",
    title: "I'd like to request a preview before print",
    description: "We email your pages for approval. Production starts once you reply, so timing depends on how quickly you approve.",
    checked: o.preview === 'yes',
    onChange: () => set('preview', 'yes')
  })), tried && !valid ? /*#__PURE__*/React.createElement("p", {
    role: "alert",
    style: {
      ...cBody,
      color: 'var(--color-error)',
      fontWeight: 600
    }
  }, "Choose one option to continue.") : null) : null, step === 4 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: cH2
  }, "Check everything"), /*#__PURE__*/React.createElement("p", {
    style: cBody
  }, "This is exactly what we will make. Tap any step above to change it.")), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gridTemplateColumns: 'minmax(110px,auto) minmax(0,1fr)',
      borderTop: '1px solid var(--color-border)'
    }
  }, orderLines(o).map(_ref2 => {
    var [k, v] = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: k
    }, /*#__PURE__*/React.createElement("dt", {
      style: {
        padding: '13px 16px 13px 0',
        borderBottom: '1px solid var(--color-border)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        color: 'var(--color-text-muted)'
      }
    }, k), /*#__PURE__*/React.createElement("dd", {
      style: {
        margin: 0,
        padding: '13px 0',
        borderBottom: '1px solid var(--color-border)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        fontWeight: 600,
        color: 'var(--color-text)',
        overflowWrap: 'anywhere'
      }
    }, v));
  })), ok ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: cLabel
  }, "Page order"), /*#__PURE__*/React.createElement("ol", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(72px,1fr))',
      gap: 10
    }
  }, o.photos.filter(p => p.state === 'uploaded').map((p, i) => /*#__PURE__*/React.createElement("li", {
    key: p.id,
    style: {
      display: 'grid',
      gap: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      aspectRatio: '1',
      borderRadius: 'var(--radius-xs)',
      background: 'var(--opg-mist)',
      overflow: 'hidden',
      display: 'grid',
      placeItems: 'center',
      color: 'var(--color-text-muted)'
    }
  }, p.src ? /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: p.src,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }) : /*#__PURE__*/React.createElement(CIcon, {
    name: "image",
    size: 18
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '0.6875rem',
      color: 'var(--color-text-muted)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, i + 1, p.caption ? ` · ${p.caption}` : ''))))) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(CCheckbox, {
    id: "c-rights",
    checked: o.rights,
    onChange: e => set('rights', e.target.checked),
    label: "These are my photographs, or I have permission to use them.",
    hint: C_FUL.returns
  }), tried && !valid ? /*#__PURE__*/React.createElement("p", {
    role: "alert",
    style: {
      ...cBody,
      color: 'var(--color-error)',
      fontWeight: 600
    }
  }, "Please confirm to continue.") : null)) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border)'
    }
  }, step > 0 ? /*#__PURE__*/React.createElement(CButton, {
    variant: "secondary",
    onClick: back
  }, "Back") : /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement(CButton, {
    variant: "primary",
    size: "lg",
    onClick: next
  }, step === 4 ? 'Continue to Secure Checkout' : `Continue to ${C_STEPS[step + 1]}`))), /*#__PURE__*/React.createElement("aside", {
    "data-opg-sticky": "",
    style: {
      minWidth: 0,
      position: 'sticky',
      top: 'calc(var(--header-height) + 24px)',
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--opg-white)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--opg-blush-100)',
      padding: 'var(--space-6)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    decoding: "async",
    src: album ? OPG_A('../../assets/web/books/jade-front.webp') : OPG_A('../../assets/web/books/luna-front.webp'),
    alt: "",
    style: {
      width: '46%',
      aspectRatio: '1122 / 1402',
      objectFit: 'cover',
      borderRadius: 3,
      boxShadow: '0 16px 30px -16px rgba(20,28,60,.5)',
      transform: 'rotate(-2deg)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-5) var(--space-6) var(--space-6)',
      display: 'grid',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-xl)',
      lineHeight: 1.15,
      color: 'var(--color-brand)'
    }
  }, o.title || (album ? C_ALBUM.title : 'Personalised Photo Colouring Book')), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 5
    }
  }, orderLines(o).slice(1, 4).map(_ref3 => {
    var [k, v] = _ref3;
    return /*#__PURE__*/React.createElement("li", {
      key: k,
      style: {
        fontSize: 'var(--text-xs)',
        lineHeight: 1.5,
        color: 'var(--color-text-muted)'
      }
    }, v);
  }), o.preview ? /*#__PURE__*/React.createElement("li", {
    style: {
      fontSize: 'var(--text-xs)',
      color: 'var(--color-text-muted)'
    }
  }, o.preview === 'yes' ? 'Preview requested' : 'No preview') : null), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      paddingTop: 14,
      borderTop: '1px solid var(--color-border)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      fontFamily: 'var(--font-sans)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-sm)',
      color: 'var(--color-text-muted)'
    }
  }, o.qty > 1 ? `${o.qty} × ${money(unit)}` : 'Total'), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--text-2xl)',
      fontWeight: 700,
      color: 'var(--color-text)'
    }
  }, money(total))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, album ? C_ALBUM.delivery : `${C_FUL.production}. ${C_FUL.shippingNote}`))), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      display: 'flex',
      gap: 10,
      fontSize: 'var(--text-xs)',
      lineHeight: 1.6,
      color: 'var(--color-text-muted)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-accent-warm)'
    }
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "check",
    size: 16
  })), "Every page is checked by a person before it is printed."))));
}
function OrderConfirmedPage(_ref4) {
  var {
    go
  } = _ref4;
  var o = window.__opgOrder || {
    product: 'book',
    size: 'a4',
    pages: 15,
    binding: 'coil',
    qty: 1,
    title: 'The Adventures of Luna',
    photos: Array.from({
      length: 15
    }, (_, i) => ({
      id: i,
      state: 'uploaded'
    })),
    preview: 'yes'
  };
  var ok = o.photos.filter(p => p.state === 'uploaded').length;
  var steps = [['Confirmation email', 'A copy of this summary is on its way to your inbox now.'], ['We check your photos', 'Every photograph is looked at by a person. If one needs a second look, we will get in touch.'], o.preview === 'yes' ? ['Your preview', 'We email your pages for approval. Production begins as soon as you reply.'] : ['We create your pages', 'Each photo is redrawn as line art and refined by hand.'], ['Printed and posted', `${C_FUL.production}. ${C_FUL.shipping}.`]];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Section, {
    tone: "paper",
    pad: "standard"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 760,
      display: 'grid',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 48,
      height: 48,
      borderRadius: '50%',
      background: 'var(--color-brand)',
      color: 'var(--opg-white)',
      display: 'grid',
      placeItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(CIcon, {
    name: "check",
    size: 24,
    strokeWidth: 2.2
  })), /*#__PURE__*/React.createElement(CEyebrow, null, "Order received"), /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 'var(--text-4xl)',
      lineHeight: 1.02,
      letterSpacing: 'var(--tracking-display)',
      color: 'var(--color-brand)',
      textWrap: 'balance'
    }
  }, "We\u2019ve got your order. Here\u2019s what happens next."), /*#__PURE__*/React.createElement("p", {
    style: {
      ...cBody,
      fontSize: 'var(--text-base)',
      maxWidth: '54ch'
    }
  }, "Thank you. ", o.title ? `“${o.title}” ` : 'Your book ', "is in our hands now, and we will look after every page."))), /*#__PURE__*/React.createElement(Section, {
    tone: "white"
  }, /*#__PURE__*/React.createElement("div", {
    "data-opg-split": "",
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,7fr) minmax(0,5fr)',
      gap: 'var(--space-8) var(--grid-gap-xl)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    style: {
      ...cH2,
      marginBottom: 'var(--space-6)'
    }
  }, "What happens next"), /*#__PURE__*/React.createElement("ol", {
    style: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      display: 'grid',
      gap: 0
    }
  }, steps.map((_ref5, i) => {
    var [t, b] = _ref5;
    return /*#__PURE__*/React.createElement("li", {
      key: t,
      style: {
        display: 'grid',
        gridTemplateColumns: '44px minmax(0,1fr)',
        gap: 16,
        paddingBlock: 18,
        borderTop: '1px solid var(--color-border)'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: 'var(--font-display)',
        fontWeight: 600,
        fontSize: 'var(--text-xl)',
        color: 'var(--color-accent-warm)',
        lineHeight: 1
      }
    }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        fontFamily: 'var(--font-sans)',
        fontWeight: 700,
        color: 'var(--color-brand)'
      }
    }, t), /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        marginTop: 6,
        ...cBody
      }
    }, b)));
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--space-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-6)',
      background: 'var(--opg-paper)',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: cLabel
  }, "Your personalisation"), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0,1fr)',
      gap: '8px 16px',
      fontSize: 'var(--text-sm)'
    }
  }, orderLines(o).map(_ref6 => {
    var [k, v] = _ref6;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: k
    }, /*#__PURE__*/React.createElement("dt", {
      style: {
        color: 'var(--color-text-muted)'
      }
    }, k), /*#__PURE__*/React.createElement("dd", {
      style: {
        margin: 0,
        fontWeight: 600,
        color: 'var(--color-text)',
        overflowWrap: 'anywhere'
      }
    }, v));
  }))), /*#__PURE__*/React.createElement("p", {
    style: {
      ...cBody
    }
  }, "Questions about your order? Email ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:enquiries@oneprintgallery.co.uk",
    style: {
      color: 'var(--color-brand)',
      fontWeight: 600
    }
  }, "enquiries@oneprintgallery.co.uk"), " and a real person will reply."), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: 'var(--space-5)',
      borderTop: '1px solid var(--color-border)',
      display: 'grid',
      gap: 10,
      justifyItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      ...cBody
    }
  }, "Know someone with a camera roll full of memories?"), /*#__PURE__*/React.createElement(CButton, {
    variant: "secondary",
    size: "sm",
    onClick: () => go('/')
  }, "Share One Print Gallery"))))));
}
Object.assign(window, {
  CreatePage,
  OrderConfirmedPage
});
;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var {
  AnnouncementBar,
  Header,
  MobileNav,
  Footer
} = window.OnePrintGalleryDesignSystem_ba4735;
var ROUTES = {
  '/': {
    nav: '/',
    render: p => /*#__PURE__*/React.createElement(Homepage, p)
  },
  '/product/': {
    nav: '/personalised-colouring-books/',
    render: p => /*#__PURE__*/React.createElement(ProductPage, p)
  },
  '/personalised-colouring-books/': {
    nav: '/personalised-colouring-books/',
    render: p => /*#__PURE__*/React.createElement(ProductPage, p)
  },
  '/photo-album/': {
    nav: '/photo-album/',
    render: p => /*#__PURE__*/React.createElement(PhotoAlbumPage, p)
  },
  '/how-it-works/': {
    nav: '/how-it-works/',
    render: p => /*#__PURE__*/React.createElement(HowItWorksPage, p)
  },
  '/one-of-one-art/': {
    nav: '/art-collection/',
    render: p => /*#__PURE__*/React.createElement(OneOfOneArtPage, p)
  },
  '/art-collection/': {
    nav: '/art-collection/',
    render: p => /*#__PURE__*/React.createElement(OneOfOneArtPage, p)
  },
  '/create/': {
    nav: '/personalised-colouring-books/',
    render: p => /*#__PURE__*/React.createElement(CreatePage, p)
  },
  '/create-album/': {
    nav: '/photo-album/',
    render: p => /*#__PURE__*/React.createElement(CreatePage, _extends({
      key: "album",
      product: "album"
    }, p))
  },
  '/personalised-colouring-books/create-your-book/': {
    nav: '/personalised-colouring-books/',
    render: p => /*#__PURE__*/React.createElement(CreatePage, _extends({
      key: "book",
      product: "book"
    }, p))
  },
  '/photo-album/create-your-album/': {
    nav: '/photo-album/',
    render: p => /*#__PURE__*/React.createElement(CreatePage, _extends({
      key: "album",
      product: "album"
    }, p))
  },
  '/order-confirmed/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(OrderConfirmedPage, p)
  },
  '/reviews/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(ReviewsPage, p)
  },
  '/faq/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(FaqPage, p)
  },
  '/contact/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(ContactPage, p)
  },
  "/__native__/": { nav: "", render: function () { return React.createElement(window.OPG_Native); } },
  '/404/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(NotFoundPage, p)
  },
  '/personalised-colouring-books/gallery/': {
    nav: '/gallery/',
    render: p => /*#__PURE__*/React.createElement(GalleryPage, p)
  },
  '/our-story/': {
    nav: '/our-story/',
    render: p => /*#__PURE__*/React.createElement(OurStoryPage, p)
  },
  '/partnerships/': {
    nav: '/partnerships/',
    render: p => /*#__PURE__*/React.createElement(PartnershipsPage, p)
  },
  '/gallery/': {
    nav: '/gallery/',
    render: p => /*#__PURE__*/React.createElement(GalleryPage, p)
  },
  '/one-of-one-art/highland-cows/': {
    nav: '/art-collection/',
    render: p => /*#__PURE__*/React.createElement(CollectionPage, _extends({
      id: "highland-cows"
    }, p))
  },
  '/one-of-one-art/obsidian-society/': {
    nav: '/art-collection/',
    render: p => /*#__PURE__*/React.createElement(CollectionPage, _extends({
      id: "obsidian-society"
    }, p))
  },
  '/partnerships/schools-sen/': {
    nav: '/partnerships/',
    render: p => /*#__PURE__*/React.createElement(SectorPage, _extends({
      id: "schools-sen"
    }, p))
  },
  '/partnerships/care-homes/': {
    nav: '/partnerships/',
    render: p => /*#__PURE__*/React.createElement(SectorPage, _extends({
      id: "care-homes"
    }, p))
  },
  '/partnerships/football-clubs/': {
    nav: '/partnerships/',
    render: p => /*#__PURE__*/React.createElement(SectorPage, _extends({
      id: "football-clubs"
    }, p))
  },
  '/shipping/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(ShippingPage, p)
  },
  '/privacy/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(PrivacyPage, p)
  },
  '/terms/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(TermsPage, p)
  },
  '/legal-notice/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(LegalNoticePage, p)
  },
  '/refunds/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(RefundsPage, p)
  },
  '/accessibility/': {
    nav: '',
    render: p => /*#__PURE__*/React.createElement(AccessibilityPage, p)
  },
  '/how-it-works/#photo-guidance': {
    nav: '/how-it-works/',
    render: p => /*#__PURE__*/React.createElement(HowItWorksPage, p)
  }
};
var OPG_REAL = {
  '/cart/': '/cart',
  '/account/': '/account',
  '/login/': '/account/login',
  '/search/': '/search'
};
var opgStart = () => {
  var h = location.hash.slice(1);
  if (ROUTES[h]) return h;
  var r = window.OPG_ROUTE;
  return ROUTES[r] ? r : '/';
};
function App() {
  var [route, setRoute] = React.useState(opgStart);
  var [menu, setMenu] = React.useState(false);
  React.useEffect(() => {
    var f = () => {
      setRoute(opgStart());
      window.scrollTo(0, 0);
    };
    addEventListener('hashchange', f);
    return () => removeEventListener('hashchange', f);
  }, []);
  var r = ROUTES[route] || ROUTES['/'];
  React.useEffect(() => { window.OPG_GO = go; });
  var go = href => {
    if (typeof href === 'string' && href.startsWith('/#/')) href = href.slice(2);
    var real = window.OPG && OPG.real && OPG.real[href];
    if (real && location.pathname !== real && !(window.OPG_BAD && OPG_BAD[real])) {
      fetch(real, { method: 'HEAD', credentials: 'same-origin' }).then(res => {
        if (res.ok) { location.href = real; return; }
        (window.OPG_BAD = window.OPG_BAD || {})[real] = 1;
        go(href);
      }).catch(() => { (window.OPG_BAD = window.OPG_BAD || {})[real] = 1; go(href); });
      return;
    }
    if ((href === '/personalised-colouring-books/' || href === '/product/') && !/^\/products\//.test(location.pathname)) {
      location.href = '/products/' + OPG.products.a4;
      return;
    }
    if (OPG_REAL[href]) {
      location.href = OPG_REAL[href];
      return;
    }
    if (!ROUTES[href]) {
      if (/^\/(products|collections|pages|cart|account|search|policies|blogs)\b/.test(href)) {
        location.href = href;
        return;
      }
      href = '/404/';
    }
    if (location.pathname !== '/') {
      location.href = '/#' + href;
      return;
    }
    setRoute(href);
    history.pushState(null, '', href === '/' ? '/' : '/#' + href);
    setMenu(false);
    window.scrollTo(0, 0);
  };
  React.useEffect(() => {
    var el = document.documentElement;
    el.style.overflow = menu ? 'hidden' : '';
    document.body.style.overflow = menu ? 'hidden' : '';
  }, [menu]);
  React.useEffect(() => {
    var f = () => setRoute(opgStart());
    addEventListener('popstate', f);
    return () => removeEventListener('popstate', f);
  }, []);
  var cap = e => {
    var a = e.target.closest('a[href]');
    var h = a && a.getAttribute('href');
    if (h && h.startsWith('/') && !a.target) {
      e.preventDefault();
      go(h.startsWith('/#/') ? h.slice(2) : h);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", { onClickCapture: cap }, React.createElement(AnnouncementBar, {
    linkLabel: "Shipping",
    linkHref: "/shipping/"
  })), /*#__PURE__*/React.createElement("div", { style: { position: "sticky", top: 0, zIndex: 80 } }, React.createElement(Header, {
    active: r.nav,
    cartCount: window.OPG && OPG.cartCount || 0,
    onNavigate: go,
    onCart: () => {
      location.href = '/cart';
    },
    onSearch: () => {
      location.href = '/search';
    },
    onMenu: () => setMenu(true)
  })), /*#__PURE__*/React.createElement("div", {
    onClickCapture: e => {
      var a = e.target.closest('a[href]');
      var h = a && a.getAttribute('href');
      if (h && h.startsWith('/') && !a.target) {
        e.preventDefault();
        go(h.startsWith('/#/') ? h.slice(2) : h);
      }
    }
  }, r.render({
    go
  }), /*#__PURE__*/React.createElement(Footer, null)), /*#__PURE__*/React.createElement(MobileNav, {
    open: menu,
    style: { position: 'fixed', inset: 0, height: '100dvh', zIndex: 200, overscrollBehavior: 'contain' },
    onClose: () => setMenu(false),
    onNavigate: go
  }));
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(App, null));